window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

$(document).on('cart.requestComplete', function(event, cart) {
  $('#afterpay_price').html('$' + (Math.round(cart.total_price / 4) / 100).toFixed(2));
});

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptionsWithoutHexOption();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Find variant without the hex option, which will be unique for each variant and only ever have one value per variant.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptionsWithoutHexOption: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;
      var selectedVariantId = 0;
      var withOptionIndex = $('[data-option-name-handle]').data('index');

      variants.forEach(function(variant) {
        if (typeof selectedValues[0] !== 'undefined')
          if (selectedValues[0].value == variant.option1)
            for (var i = 0; i < window.variantQuantities.length; i++)
                if(variant.id == window.variantQuantities[i].id)
                {

                  if(window.variantQuantities[i].qty < 30)
                  {
                    $("#available-text").html("Less than 30 Left");
                    $(".product-counter").css("background-color","#efbd4e");
                    $(".product-counter").show();
                  }

                  if(window.variantQuantities[i].qty < 10)
                  {
                    $("#available-text").html("Less than 10 Left");
                    $(".product-counter").css("background-color","#F05A60");
                    $(".product-counter").show();
                  }

                  if(window.variantQuantities[i].qty === 0)
                  {
                    $(".product-counter").hide();
                  }

                  if(window.variantQuantities[i].qty > 30)
                  {
                    $(".product-counter").hide();
                  }

                }

        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied && option.index == withOptionIndex) {
            satisfied = (option.value === variant[option.index]);
          }


        });

        if (satisfied) {
          found = variant;
        }

      });

      return found || null;
    },


    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {

      var variant = this._getVariantFromOptionsWithoutHexOption();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      $('[data-current-variant-id]').val(variant.id);
      $('[data-variant-id]').attr('data-variant-id', variant.id);

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      this._updateData(variant);
      this._updateBundleDisplay(variant);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

    /**
     * Update miscellaneous data attributes
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateData: function(variant) {
      $('[data-variant-switch] [data-cart-add]').attr('data-cart-add', variant.id);
      $('[data-variant-switch] [data-add-quantity]').attr('data-add-quantity', variant.id);
    },

    /**
     * Update bundle display on bundle products
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateBundleDisplay: function(variant) {
      $('[data-bundle-display]').fadeOut();
      $('[data-bundle-display="' + variant.id + '"]').fadeIn();
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    switchEnabled: '[data-variant-switch]',
    addToCartWrap: '[data-add-to-cart-wrap]',
    BISTrigger: '[data-bis-trigger]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.switchEnabled + ' ' + selectors.priceWrapper).removeClass('hide');
      } else {
        $(selectors.switchEnabled + ' ' + selectors.addToCart).prop('disabled', true);
        $(selectors.switchEnabled + ' ' + selectors.addToCartText).html(theme.strings.unavailable);
        $(selectors.switchEnabled + ' ' + selectors.priceWrapper).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.switchEnabled + ' ' + selectors.addToCart).prop('disabled', false);
        $(selectors.switchEnabled + ' ' + selectors.addToCartText).html(theme.strings.addToCart);

        //show add to cart, hide BIS trigger - related to Back In Stock app
        $(selectors.switchEnabled + ' ' + selectors.addToCartWrap).removeClass('hide');
        $(selectors.switchEnabled + ' ' + selectors.BISTrigger).addClass('hide');
        //
      } else {
        $(selectors.switchEnabled + ' ' + selectors.addToCart).prop('disabled', true);
        $(selectors.switchEnabled + ' ' + selectors.addToCartText).html(theme.strings.soldOut);

        //show BIS trigger, hide add to cart - related to Back In Stock app
        $(selectors.switchEnabled + ' ' + selectors.addToCartWrap).addClass('hide');
        $(selectors.switchEnabled + ' ' + selectors.BISTrigger).removeClass('hide');
        //
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);

      if(this.$featuredImage.hasClass('image-zoom')) {
        this.$featuredImage.parent().trigger('zoom.destroy').zoom({url: sizedImgUrl});
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();



/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '.recover_password',
    hideRecoverPasswordLink: '.hide_recover_password'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/*
	Product page functionality
*/
$(document).ready(function () {

    var $optionLabel = $('.variant-label'),
        $productVariantTitle = $('.product-variant-title'),
        $productVariantSwatch = $('.product-variant-swatch'),
        $minusIcon = $('.minus'),
        $plusIcon = $('.plus');

    /* dynamic change product variant title and swatch */
    $optionLabel.on('click', function () {
        $(this).siblings('input[type=radio]').val();
        $productVariantTitle.text($(this).siblings('input[type=radio]').val());
        $productVariantSwatch.css("background-color", $(this).css("background-color"));
    });

    /* show the image on variant change */
    $optionLabel.on('click', function () {
        // hide award icon
        if ($('[data-product-featured-icon]').is(':visible')) {
            $('[data-product-featured-icon]').hide();
        }
        if ($('[data-product-featured-video]').parent().length > 0) {
            if ($('[data-product-featured-video]').parent().is(':visible')) {
                $('[data-product-featured-video]').parent().get(0).pause();
                $('[data-product-featured-video]').parent().hide();
                $('[data-product-featured-image]').show();
            }
        }
    });

    /* change qty of products */
    $minusIcon.on('click', function () {
        var inputTypeNumber = $(this).siblings('input[type=number]');
        if (+inputTypeNumber.val() > 1) {
            inputTypeNumber.val(+inputTypeNumber.val() - 1).trigger('change');
        }
    });

    $plusIcon.on('click', function () {
        var inputTypeNumber = $(this).siblings('input[type=number]');
        inputTypeNumber.val(+inputTypeNumber.val() + 1).trigger('change');
    });

    /* product image zoom init only on devices bigger than tablet */
    /* product image zoom init */
    // if (window.screen.width > 1024) {
    //     $('.image-zoom')
    //         .wrap('<span class="zoom" style="display:inline-block"></span>')
    //         .css('display', 'block')
    //         .parent()
    //         .zoom({
    //             url: $(this).find('img').attr('data-zoom')
    //         });
    // }

    $('input[name="Shade"]').on('change', function () {
        $('[data-option-name-handle="' + 'Shade' + '"]').val($(this).val()).change();
    });

    $(".vimeo-wrapper").fitVids();

});

function showExtendedShades() {
    $('[data-extended-shade]').fadeIn();
    $(event.target).fadeOut();
}

// Product image switching
$('[data-product-single-thumbnail]').on('click', function (e) {
    e.preventDefault();
    var switchImageUrl = $(this).find('img').attr('data-full-src');
    // hide award icon
    if ($('[data-product-featured-icon]').is(':visible')) {
        $('[data-product-featured-icon]').hide();
    }
    $('[data-product-featured-image]').attr('src', switchImageUrl).parent();
    $('[data-product-featured-video]').parent().get(0).pause();
    $('[data-product-featured-video]').parent().hide();
    $('[data-product-featured-image]').show();
});

// Product video click
$('[data-product-video-thumbnail]').on('click', function (e) {
    e.preventDefault();
    var switchVideoUrl = $(this).find('img').attr('data-full-src');
    // hide award icon
    if ($('[data-product-featured-icon]').is(':visible')) {
        $('[data-product-featured-icon]').hide();
    }
    $('[data-product-featured-video]').attr('src', switchVideoUrl).parent();
    $('[data-product-featured-image]').hide();
    $('[data-product-featured-video]').parent().show();
    $('[data-product-featured-video]').parent().get(0).play();
});

Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
// jQuery('#sort-select')
//   .bind('change', function() {
//     Shopify.queryParams.sort_by = jQuery(this).val();
//     location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
//   });

$(".truncate-lines-read-more").on('click', function() {
  $(this).parents('.truncate-lines-container').find('.truncate-lines-text').removeClass('truncate-3-lines');
  $(this).fadeOut();
});

function isOverflown(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

$(document).ready(function() {
  $(".truncate-lines-text").each(function() {
    if (isOverflown(this)) {
      $(this).parents('.truncate-lines-container').find('.truncate-lines-read-more').show();
    } else {
      $(this).parents('.truncate-lines-container').find('.truncate-lines-read-more').hide();
      $(this).parents('.truncate-lines-container').find('.truncate-lines-text').removeClass('truncate-3-lines');
    }
  });
});

/*=============== Components ================*/
// Get querystring parameters
function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
/*
	Accordion functionality
*/
$(document).ready(function() {

  var $window = $(window),
			accItemHead = $('.accordion-head'),
      collectionPage = $('.collection-page'),
			blogPage = $('.blog-page'),
      accordionItem = $('.accordion');

  accItemHead.click(function () {
		var accItemWrap = $(this).parent('.accordion');
    accItemWrap.hasClass('active') ? accItemWrap.removeClass('active') : accItemWrap.addClass('active');
  });

	// function toggleAccordion() {
	//   if (collectionPage.length || blogPage.length) {
	//     if ($window.width() > 767) {
	// 		  accordionItem.addClass('active');
	// 	  } else {
	// 	    accordionItem.removeClass('active');
	//     }
	//   }
	// }
	//
	// toggleAccordion();
	//
	// $window.on('resize orientationchange', function() {
	// 	toggleAccordion();
	// });

});
var cartCount = 0;
var updateLabel = "";
var translationsCountrySelector = "";

// Get the country
if (window.location.host === 'nudebynature.fr' || window.location.host === 'fr.nudebynature.ca') {
    translationsCountrySelector = "fr"
} else if (window.location.host === 'nudebynature.de') {
    translationsCountrySelector = "de"
} else if (window.location.host === 'nudebynature.pl') {
    translationsCountrySelector = "pl"
} else {
    translationsCountrySelector = "en"
}

// Translated content
var translationsCartButton = {
    en: {
        added: "Added",
        adding: "Adding",
        plus_qty_to_cart: "Plus Qty to Cart",
        added_to_cart: "Added to Cart",
        error: "Error",
        add_to_bag: "Add to Bag",
        removed_from_cart: "Removed from Cart",
        minus_qty_from_cart: "Minus Qty from Cart"
    },
    fr: {
        added: "Ajouté",
        adding: "En Cours",
        plus_qty_to_cart: "",
        added_to_cart: "Ajouté au panier",
        error: "Erreur",
        add_to_bag: "Ajouter au panier",
        removed_from_cart: "Retiré du panier",
        minus_qty_from_cart: ""
    },
    de: {
        added: "Hinzugefügt",
        adding: "Hinzufügen",
        plus_qty_to_cart: "",
        added_to_cart: "",
        error: "Error",
        add_to_bag: "In den Einkaufswagen legen",
        removed_from_cart: "",
        minus_qty_from_cart: ""
    },
    pl: {
        added: "Dodany",
        adding: "Dodawanie",
        plus_qty_to_cart: "",
        added_to_cart: "Dodano do koszyka",
        error: "Błąd",
        add_to_bag: "Dodaj do torby",
        removed_from_cart: "Usunięto z koszyka",
        minus_qty_from_cart: ""
    }
};

$(document).on('cart.requestStarted', function (event, cart) {
    cartCount = cart.item_count;

    var $target = (window.selectorButton !== undefined) ? $(window.selectorButton.button) : $(event.target);

    if ($target !== null)
        $target.text(translationsCartButton[translationsCountrySelector]["adding"]);

});

$(document).on('cart.requestComplete', function (event, cart) {
    var $target = (window.selectorButton !== undefined) ? $(window.selectorButton.button) : $(event.target);
    if (cart.item_count > cartCount) {
        $target.text(translationsCartButton[translationsCountrySelector]["added"]);

        // Choose the correct label for the segment push
        if (updateLabel !== "Plus Qty to Cart")
            updateLabel = translationsCartButton[translationsCountrySelector]["added_to_cart"];

    } else {
        $target.text(translationsCartButton[translationsCountrySelector]["error"]);
    }
    setTimeout(function () {
        $target.text(translationsCartButton[translationsCountrySelector]["add_to_bag"]);
    }, 2000);
    cartCount = 0;

    var cartTotalPrice = cart.total_price;
    var cartQty = cart.item_count;

    //Update item count
    $('[data-cart-count]').html(cartQty);
    //Update cart totals
    $('[data-cart-total]').html('<span class="money" data-currency="' + Currency.currentCurrency + '" data-currency-' + Currency.currentCurrency + '="' + slate.Currency.formatMoney(Currency.convert(cartTotalPrice, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format) + '">' + slate.Currency.formatMoney(Currency.convert(cartTotalPrice, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('') + '</span>');
    $('[data-cart-total-points]').html(Math.floor(cartTotalPrice / 100 * 2));
    //Remove removed line items
    $('[data-remove-line]').remove();

    // GWP
    if ((window.location.host === "nudebynature.com.au" || window.location.host === "nudebynature.co.nz" || window.location.host === "nudebynature.co.uk" || window.location.host === "nudebynature-dev.myshopify.com") && (window.location.pathname.includes("cart"))) {
        // Hide area
        $("#gwp-display").hide();
        // Hide all products
        for (var i = 0; i < 3; i++) {
            $("#gwp-display-" + i).hide();
        }

        // Empty all offer sections
        for (var i = 0; i < 3; i++) {
            $("#gwp-display-" + i + "-image").attr('src', '');
            $("#gwp-display-" + i + "-image-url").attr('href', '');
            $("#gwp-display-" + i + "-title").text('');
            $("#gwp-display-" + i + "-coupon-code").text('');
            $("#gwp-display-" + i + "-button").attr('data-add-to-cart', '');
            $("#gwp-display-" + i + "-button").attr('data-cart-add', '');
        }

        // Set default message and show it
        $('#gwp-qualify-message')
            .html('Rechecking for free gift offers...')
            .show();

        // Hide code reminder message and empty it
        $('#gwp-code-reminder')
            .hide()
            .html('');
    }


    if (cart.items.length > 0) {
        //Update line totals
        for (var i = 0; i < cart.items.length; i++) {
            $('[data-line-index="' + (i + 1) + '"] [data-line-total]').html('<span class="money" data-currency="' + Currency.currentCurrency + '" data-currency-' + Currency.currentCurrency + '="' + slate.Currency.formatMoney(Currency.convert(cart.items[i].line_price, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format) + '">' + slate.Currency.formatMoney(Currency.convert(cart.items[i].line_price, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('') + '</span>');
        }

        //Update free shipping text
        var freeShippingThreshold = $('[data-shipping-threshold]').data('shipping-threshold');
        var freeShippingDifference = freeShippingThreshold - cartTotalPrice;
        if (freeShippingDifference >= 0) {
            $('.shipping-text').html('You\'re <span class="money" data-currency="' + Currency.currentCurrency + '" data-currency-' + Currency.currentCurrency + '="' + slate.Currency.formatMoney(Currency.convert(freeShippingDifference, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format) + '">' + slate.Currency.formatMoney(Currency.convert(freeShippingDifference, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('') + '</span> away from <br/><span class="semibold">free shipping!</span>');

        if ($('#afterpay_price').length == 1)
            $('#afterpay_price').html('$' + (Math.round(cartTotalPrice / 4) / 100).toFixed(2));

        } else {
            $('.shipping-text').html('You qualify for <br/><span class="semibold">free shipping!</span>');
        }

        var sendData = [];

        Object.keys(cart.items).forEach(function(key) {
            sendData.push({ title: cart.items[key].product_title, product_id: cart.items[key].product_id, price: cart.items[key].price, quantity: cart.items[key].quantity, product_type: cart.items[key].product_type });
        });

        // GWP
        if ((window.location.host === "nudebynature.com.au" || window.location.host === "nudebynature.co.nz" || window.location.host === "nudebynature.co.uk" || window.location.host === "nudebynature-dev.myshopify.com") && (window.location.pathname.includes("cart"))) {
            jQuery.ajax({
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify({data: sendData, referrer: window.location.host }),
                dataType: "json",
                url: 'https://api.nudebynature.com/v2/gwp', //'https://nbn-dev-nodejs.herokuapp.com/gwp-display',
                success: function (response) {

                    // Empty the products
                    document.getElementById("gwp-products").innerHTML = "";

                    if (response.qualifyGWPProductInfo.length > 0) {

                        var inStock = true;
                        var outOfStockCount = 0;
                        var inBag = false;
                        var inBagCount = 0;

                        // if (response.qualifyGWPProductInfo.length > 3) {
                        //     for (var i = 0; i < 3; i++) {
                        //         document.getElementById("gwp-products").innerHTML += '<div id="gwp-display-' + i + '" class="col-sm-3 col-xs-6 prod-column" style="display:none;"><a href="" class="coll-product-image-link" id="gwp-display-' + i + '-image-url"><img id="gwp-display-' + i + '-image" src=""></a><div class="coll-product-info-box vert-space-between-wrapper"><div class="inner-wrap"><a href="" id="gwp-display-' + i + '-title-url"><h4 class="coll-product-title gwp-title" id="gwp-display-' + i + '-title"></h4></a><p id="gwp-display-' + i + '-qualify-status" class="gwp-qualify-status"></p><p id="gwp-display-' + i + '-qualify-message" class="gwp-qualify-message"></p><p id="gwp-display-' + i + '-coupon-code" class="gwp-coupon-code"></p></div><div class="inner-wrap"><div class="coll-product-price"></div><button type="submit" id="gwp-display-' + i + '-button" class="add-btn dark-brown-btn coll-add-btn lf-match-add-btn gwp-add-btn" data-add-to-cart="123" data-cart-quantity="1" data-cart-add="123"><span data-add-to-cart-text="Add to Bag">Add to Bag</span></button></div></div></div>'
                        //     }
                        // } else {
                        //     for (var i = 0; i < response.qualifyGWPProductInfo.length; i++) {
                        //         document.getElementById("gwp-products").innerHTML += '<div id="gwp-display-' + i + '" class="col-sm-3 col-xs-6 prod-column" style="display:none;"><a href="" class="coll-product-image-link" id="gwp-display-' + i + '-image-url"><img id="gwp-display-' + i + '-image" src=""></a><div class="coll-product-info-box vert-space-between-wrapper"><div class="inner-wrap"><a href="" id="gwp-display-' + i + '-title-url"><h4 class="coll-product-title gwp-title" id="gwp-display-' + i + '-title"></h4></a><p id="gwp-display-' + i + '-qualify-status" class="gwp-qualify-status"></p><p id="gwp-display-' + i + '-qualify-message" class="gwp-qualify-message"></p><p id="gwp-display-' + i + '-coupon-code" class="gwp-coupon-code"></p></div><div class="inner-wrap"><div class="coll-product-price"></div><button type="submit" id="gwp-display-' + i + '-button" class="add-btn dark-brown-btn coll-add-btn lf-match-add-btn gwp-add-btn" data-add-to-cart="123" data-cart-quantity="1" data-cart-add="123"><span data-add-to-cart-text="Add to Bag">Add to Bag</span></button></div></div></div>'
                        //     }
                        // }

                        for (var i = 0; i < response.qualifyGWPProductInfo.length; i++) {

                            // Add the gwp
                            // document.getElementById("gwp-products").innerHTML += '<div id="gwp-display-' + i + '" class="col-sm-3 col-xs-6 prod-column" style="display:none;"><a href="" class="coll-product-image-link" id="gwp-display-' + i + '-image-url"><img id="gwp-display-' + i + '-image" src=""></a><div class="coll-product-info-box vert-space-between-wrapper"><div class="inner-wrap"><a href="" id="gwp-display-' + i + '-title-url"><h4 class="coll-product-title gwp-title" id="gwp-display-' + i + '-title"></h4></a><p id="gwp-display-' + i + '-qualify-status" class="gwp-qualify-status"></p><p id="gwp-display-' + i + '-qualify-message" class="gwp-qualify-message"></p><p id="gwp-display-' + i + '-coupon-code" class="gwp-coupon-code"></p></div><div class="inner-wrap"><div class="coll-product-price"></div><button type="submit" id="gwp-display-' + i + '-button" class="add-btn dark-brown-btn coll-add-btn lf-match-add-btn gwp-add-btn" data-add-to-cart="123" data-cart-quantity="1" data-cart-add="123"><span data-add-to-cart-text="Add to Bag">Add to Bag</span></button></div></div></div>'
                            // New
                            document.getElementById("gwp-products").innerHTML += '<div id="gwp-display-' + i + '" class="col-sm-3 col-xs-6 prod-column gwp-column" style="display:none;"><a href="" class="coll-product-image-link" id="gwp-display-' + i + '-image-url"><img id="gwp-display-' + i + '-image" src=""></a><a href="" id="gwp-display-' + i + '-title-url"><h4 class="coll-product-title gwp-title" id="gwp-display-' + i + '-title"></h4></a><p id="gwp-display-' + i + '-qualify-status" class="gwp-qualify-status"></p><p id="gwp-display-' + i + '-qualify-message" class="gwp-qualify-message"></p><p id="gwp-display-' + i + '-coupon-code" class="gwp-coupon-code"></p><div class="coll-product-price"></div><button type="submit" id="gwp-display-' + i + '-button" class="add-btn dark-brown-btn coll-add-btn lf-match-add-btn gwp-add-btn" data-add-to-cart="123" data-cart-quantity="1" data-cart-add="123"><span data-add-to-cart-text="Add to Bag">Add to Bag</span></button></div>';

                            var gwpObj = response.qualifyGWPProductInfo[i];

                            // If out of stock skip it
                            if (gwpObj.inStock === false) {
                                inStock = false;
                                outOfStockCount += 1;
                                continue
                            }

                            if (gwpObj.in_bag === true) {
                                inBag = true;
                                inBagCount += 1;
                                continue
                            }


                            // Build the GWP objects
                            $("#gwp-display-" + i).toggle();
                            $("#gwp-display-" + i + "-image").attr('src', gwpObj.image);
                            $("#gwp-display-" + i + "-image-url").attr('href', gwpObj.url);
                            $("#gwp-display-" + i + "-title-url").attr('href', gwpObj.url);
                            $("#gwp-display-" + i + "-title").text(gwpObj.title);
                            $("#gwp-display-" + i + "-coupon-code").text(gwpObj.discountCode);
                            $("#gwp-display-" + i + "-button").attr('data-add-to-cart', gwpObj.variant);
                            $("#gwp-display-" + i + "-button").attr('data-cart-add', gwpObj.variant);

                            // Handle qualification of GWPs
                            // If not valid tell them
                            if (gwpObj.qualify === false) {
                                // NORMAL GWP MESSAGING
                                $("#gwp-display-" + i + "-qualify-status").text("YOU NEARLY QUALIFY");
                                $("#gwp-display-" + i + "-qualify-message").text(gwpObj.qualifyMessage);
                            } else {
                                // NORMAL GWP MESSAGING
                                $("#gwp-display-" + i + "-qualify-status").text("YOU QUALIFY");
                                $("#gwp-display-" + i + "-qualify-message").text("Add to your bag and use the following code on checkout");
                            }

                            // GWP
                            // $("#gwp-display-" + i + "-qualify-message").text("Add to bag and get free on orders over $130");

                            // // Event listener for click event
                            // $("#gwp-display-" + i + "-button").click(function() {
                            //     $("#gwp-cart-refresh").text('Adding product and refreshing page...').slideDown();
                            //     $("#gwp-display").slideUp();
                            //     setTimeout(function() {
                            //         location.reload();
                            //     }, 3000);
                            // });

                            // // Can only handle three GWPs
                            // if (i >= 3) {
                            //     break;
                            // }
                        }

                        if (inBagCount !== response.qualifyGWPProductInfo.length && outOfStockCount !== response.qualifyGWPProductInfo.length) {
                            $("#gwp-display").slideDown();
                        }

                        if (inStock === false) {
                            $('#gwp-qualify-message').html('There are no active free gift offers')
                        } else {
                            $('#gwp-qualify-message').html('There are free gifts available<br><span class="semibold"><a href="#gwp-display">See below to check if you qualify!</a></span>')
                        }

                    }


                    // For some reason I need to add the button events here because with multiple GWPs the first button event doesn't add to the element
                    var buttons = document.getElementsByClassName('gwp-add-btn');
                    for (var i=0; i < buttons.length; i++) {
                        buttons[i].addEventListener('click', function() {
                            $("#gwp-cart-refresh").text('Adding product and refreshing page...').slideDown();
                            $("#gwp-display").slideUp();
                            setTimeout(function() {
                                location.reload();
                            }, 3000);
                        })
                    }


                    if (response.inCartGWPCodes.length > 0) {
                        $('#gwp-qualify-message').html('').slideUp();

                        // If they have multiple gifts in bag
                        if (response.inCartGWPCodes.length === 1) {
                            // NORMAL MESSAGING
                            $('#gwp-code-reminder')
                                .html("You have a gift in your bag. Don't forget to use one of these codes on checkout<br><br><span class=\"semibold\">" + response.inCartGWPCodes.join("<br>") + "</span>")
                                .slideDown();
                            // MESSAGING
                            // $('#gwp-code-reminder')
                            //     .html("You have a gift in your bag. Make sure your bag is at least $130 and use this coupon code on checkout<br><br><span class=\"semibold\">" + response.inCartGWPCodes.join("<br>") + "</span>")
                            //     .slideDown();
                        } else if (response.inCartGWPCodes.length > 1) {
                            $('#gwp-code-reminder')
                                .html("You have multiple gifts in your bag, only one is free. Use one of these codes on checkout<br><br><span class=\"semibold\">" + response.inCartGWPCodes.join("<br>") + "</span>")
                                .slideDown();
                        }
                    }

                    if (response.inCartGWPCodes.length === 0 && response.qualifyGWPProductInfo.length === 0) {
                        $('#gwp-qualify-message').html('There are no active free gift offers')
                    }

                },
                error: function (error) {}
            });
        }

    } else {
        //show empty cart text
        $('[data-cart-content]').fadeOut();
        $('[data-empty-cart-text]').fadeIn();
    }

    // Push this cart event and the cart data to Segment
    nbnCartSegment(cart, updateLabel);

});

$('[data-cart-remove]').on('click', function () {
    //Fade cart line out on remove and mark for removal on cart update
    var lineIndex = $(this).attr('data-cart-remove');
    $('[data-line-index="' + lineIndex + '"]').fadeOut().attr('data-remove-line', '');

    //Change other line indexes to reflect updated cart
    $('[data-line-index]').each(function () {
        if ($(this).attr('data-line-index') > lineIndex) {
            $(this).attr('data-line-index', $(this).attr('data-line-index') - 1);
            var lineRemove = $(this).find('[data-cart-remove]');
            var lineQtyUpdate = $(this).find('[data-cart-update]');
            $(lineRemove).attr('data-cart-remove', $(lineRemove).attr('data-cart-remove') - 1);
            $(lineQtyUpdate).attr('data-cart-update', $(lineQtyUpdate).attr('data-cart-update') - 1);
        }
    });

    updateLabel = translationsCartButton[translationsCountrySelector]["removed_from_cart"];
});

$('[data-add-quantity]').on('change', function () {
    //Use quantity field for product add
    var addQty = $(this).val();
    $(this).parents('form').find('[data-cart-add="' + $(this).attr('data-add-quantity') + '"]').attr('data-cart-quantity', $(this).val());
    $('[data-univ-quantity]').each(function () {
        if ($(this).val() != addQty) {
            $(this).val(addQty).change();
        }
    });

    updateLabel = translationsCartButton[translationsCountrySelector]["removed_from_cart"];
});


$('[data-minus-qty]').on('click', function () {
    updateLabel = translationsCartButton[translationsCountrySelector]["minus_qty_from_cart"];
});

$('[data-plus-qty]').on('click', function () {
    updateLabel = translationsCartButton[translationsCountrySelector]["plus_qty_to_cart"];
});


/*
Notes:

The .money selector applies to the currency switcher implementation, which requires it be inserted in the HTML money formats in the CMS. If no currency switcher is used, it needn't be added.

[data-add-quantity] should be a variant id and affects the corresponding product add element.

To Do: establish a framework for quantity input affecting only its local product add element.
*/


$('.currency.select-wrap select.currency-picker').on('change', function() {
	$('.currency.select-wrap select.currency-picker:not(this)').val($(this).val());
});
$('.currency.select-wrap select').on('change', function() {
  $(this).parents('.currency.select-wrap').attr('data-store', $(this).find('option:selected').attr('data-store'));
  window.location.href = $(this).val();
});
/*
Commented out setSliderMinMax() because slider isn't loading
 */

/*
	Collection filter functionality
*/
$(document).ready(function () {

    if (window.location.href.indexOf("collections") > -1) {

        var url = window.location.origin + window.location.pathname;
        var arrayOfActiveLinks = [];
        var htmlSplitter = '<!--collection_splitter-->';
        var $container = $('#coll-products-wrapper-id');
        var allProductsQty = 0;
        var productsPageQty = 0;
        var filteredArrLength = 0;
        var paginateValue = Number($('#paginate-value').text().trim());
        var isPageClick = false;
        var isSingleOption = false;
        var minPrice = 0;
        var maxPrice = 0;
        var currentMinPrice = 0;
        var currentMaxPrice = 1000;
        var isPriceFilter = false;
        var limit = 250;
        var clearBtn = $('#price-slider .clear-btn');
        var bothSliderPrices = $('.slider-values.both-prices');
        var minSliderPrice = $('.slider-values.min-value');
        var maxSliderPrice = $('.slider-values.max-value');
        var $slider = $('#slider-range');
        var sortSelect = $('#sort-select');
        var renderBool = false;
        var spinner = $('#loader');
        var spinnerWrapper = $('#loader-wrapper');


        var collectionFilters = {};

        function createPropertiesForCollectionFilter() {
            $('.accordion-body[data-tag]').each(function (i) {
                var propName = $('.accordion-body[data-tag]').eq(i).attr('data-tag');
                collectionFilters[propName] = [];
            });
        }

        function formatMaxPrice(max) {
            if (max % 5 === 0) {
                return max;
            } else {
                return max + (5 - max % 5);
            }
        }

        function setSliderMinMax() {
            isPriceFilter = false;
            $slider.slider('values', [minPrice, maxPrice]);

            minSliderPrice.html(slate.Currency.formatMoney(Currency.convert(minPrice * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('')).position({
                my: 'left',
                at: 'left',
                of: $('.ui-slider-handle').eq(0)
            });
            maxSliderPrice.html(slate.Currency.formatMoney(Currency.convert(maxPrice * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('')).position({
                my: 'right',
                at: 'right',
                of: $('.ui-slider-handle').eq(1)
            });
            $('.slider-values .min-value').html(slate.Currency.formatMoney(Currency.convert(minPrice * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format.split('"').join('')))
            $('.slider-values .max-value').html(slate.Currency.formatMoney(Currency.convert(maxPrice * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format.split('"').join('')));
        }

        function formatToIntegerNum(item) {
            return Math.round(+item / 100);
        }

        function getMaxPrice() {
            var productsTotal = 0;
            var arrayOfprices = [];
            var max = 0;

            function getMaxPricePerPages(count, pagesQty) {
                $.when($.get(url + '?page=' + count + '&view=price-json' + '&req=' + $.now()))
                    .then(function (data) {
                        arrayOfprices = arrayOfprices.concat(data.trim().split(',').map(formatToIntegerNum));
                        if (count < pagesQty) {
                            getMaxPricePerPages(++count, pagesQty);
                        } else {
                            max = Math.max.apply(null, arrayOfprices);
                            maxPrice = formatMaxPrice(max);
                            //refresh slider values
                            $slider.slider("option", "max", maxPrice);
                            // Comment out for non-transactional
                            setSliderMinMax();
                        }
                    });
            }

            $.when($.getJSON(url))
                .then(function (dataCount) {
                    productsTotal = +dataCount.collection.products_count;
                    if (productsTotal <= limit) {
                        $.when($.get(url + '?view=price-json'))
                            .done(function (data) {
                                arrayOfprices = data.trim().split(',').map(formatToIntegerNum);
                                max = Math.max.apply(null, arrayOfprices);
                                maxPrice = formatMaxPrice(max);
                                //refresh slider values
                                $slider.slider("option", "max", maxPrice);
                                // Comment out for non-transactional
                                setSliderMinMax();
                            });
                    } else {
                        var pages = 0;
                        if (productsTotal % limit === 0) {
                            pages = productsTotal / limit;
                        } else {
                            pages = Math.floor(productsTotal / limit) + 1;
                        }
                        var count = 1;
                        getMaxPricePerPages(count, pages);
                    }
                });
        }

        function showHiddenValues(minPriceEl, maxPriceEl, bothPricesEl, sliderWrap) {
            var minPriceRightCoord = minPriceEl.offset().left + minPriceEl.width();
            var bothPriceRightPoint = $('.ui-slider-handle').eq(0).offset().left + bothPricesEl.width();
            var sliderWrapRightBorder = sliderWrap.offset().left + sliderWrap.width();
            if ((minPriceRightCoord + $('.slider-values .gap').width()) >= maxPriceEl.offset().left) {
                bothPricesEl.css({'visibility': 'visible', 'opacity': '1'}).addClass('visible');
                minPriceEl.css({'visibility': 'hidden', 'opacity': '0'});
                maxPriceEl.css({'visibility': 'hidden', 'opacity': '0'});
            } else {
                bothPricesEl.css({'visibility': 'hidden', 'opacity': '0'}).removeClass('visible');
                minPriceEl.css({'visibility': 'visible', 'opacity': '1'});
                maxPriceEl.css({'visibility': 'visible', 'opacity': '1'});
            }
            if (bothPriceRightPoint >= sliderWrapRightBorder) {
                bothPricesEl.position({
                    my: 'right',
                    at: 'right+4',
                    of: $slider
                });
            } else {
                bothPricesEl.position({
                    my: 'left',
                    at: 'left',
                    of: $('.ui-slider-handle').eq(0)
                });
            }
        }

        function renderPagination(prodArrLength, paginateValue, currentPage) {
            var pagesCount = 0;
            if (currentPage == undefined) {
                currentPage = +$('#pagination span.current a').text().trim();
            }
            var pagesCount = (prodArrLength % paginateValue == 0) ? prodArrLength / paginateValue : Math.floor(prodArrLength / paginateValue) + 1;
            var paginationContainer = $('#pagination');
            var pageNumFirstPart = '<span class="page page-num mid"><a href="">';
            var firstPage = '<span class="page page-num first"><a href="">';
            var lastPage = '<span class="page page-num last"><a href="">';
            var pageNumSecondPart = '</a></span>';
            var prevPage = '<span class="prev page-arrow" style="display: none;"><a href=""></a></span>';
            var nextPage = '<span class="next page-arrow"><a href=""></a></span>';
            var deco = '<span class="deco"><a href="">…</a></span>';
            var paginationHTML = prevPage;
            var pageIterator = currentPage == undefined ? 1 : currentPage - 2;
            if (currentPage == undefined) {
                var pageIterator = 1;
            } else {
                var pageIterator = currentPage - 2;
                if (pageIterator <= 0) {
                    pageIterator = 1;
                }
            }
            for (var i = 1; i <= pagesCount; i++) {
                if (i == 1) {
                    paginationHTML += firstPage + pageIterator + pageNumSecondPart;
                } else if (i == pagesCount) {
                    paginationHTML += lastPage + i + pageNumSecondPart;
                } else {
                    paginationHTML += pageNumFirstPart + pageIterator + pageNumSecondPart;
                }
                if (pagesCount > 5 && i === 3) {
                    paginationHTML += deco;
                    i = pagesCount - 1;
                }
                pageIterator++;
            }
            paginationHTML += nextPage;
            paginationContainer.empty().html(paginationHTML);
            if (currentPage) {
                $('#pagination span a').each(function (i) {
                    if ($('#pagination span a').eq(i).text().trim() == currentPage) {
                        $('#pagination span a').eq(i).parent('span').addClass('current');
                    }
                });
            } else {
                $('#pagination span.first').addClass('current');
            }

            if ($('#pagination span.first').hasClass('current') && $('#pagination span.first a').text().trim() == 1) {
                $('#pagination span.prev').hide();
            } else if ($('#pagination span.last').hasClass('current')) {
                $('#pagination span.next').hide();
            } else {
                $('#pagination span.prev, #pagination span.next').show();
            }

            $('#pagination a').on('click', function (event) {
                pageClickHandler(event, $(this));
            });
        }

        function updatePagination(productsPageArrlength, allProductsArrlength, currentPageNum) {
            if (productsPageArrlength < paginateValue && allProductsArrlength <= paginateValue) {
                $('#pagination').hide();
                $('#pagination .current').removeClass('current');
                $('#pagination .first').addClass('current');
            } else if (productsPageArrlength == paginateValue) {
                if (allProductsArrlength > paginateValue) {
                    $('#pagination').show();
                    renderPagination(allProductsArrlength, paginateValue, currentPageNum);
                } else {
                    $('#pagination').hide();
                    $('#pagination .first').addClass('current');
                }
            }
        }

        function paginateProducts(array, currentPage) {
            if (currentPage == undefined) {
                currentPage = Number($('#pagination .current').text().trim());
            }
            return array.slice(paginateValue * currentPage - paginateValue, paginateValue * currentPage);
        }

        function cleanSpacesInArrayItem(item) {
            return item.trim();
        }

        function removeEmptyArrayItem(item) {
            return item != '';
        }

        function removeLinkFromArray(arrItem) {
            return arrItem !== getFilterTagOption(this);
        }

        function updateProductsQty(pageQty, allQty) {
            $('#products-shown').text(pageQty);
            $('#products-total').text(allQty);
        }

        function parseAllLinks(linkList) {
            var allCategoryLinks = [];
            linkList.each(function (index) {
                allCategoryLinks.push(getFilterTagOption($(this)));
            });
            return allCategoryLinks;
        }

        function filterByPrice(productsArray, dataAttr) {
            var filteredByPriceArray = [];
            for (var i = 0; i < productsArray.length; i++) {
                var attrEndPoint = productsArray[i].indexOf(dataAttr) + dataAttr.length + 1;
                var lastAttrPosition = attrEndPoint + productsArray[i].slice(attrEndPoint).indexOf(" ");
                var priceAtrrVal = productsArray[i].slice(attrEndPoint + 1, lastAttrPosition - 1);
                var productPrice = Number(priceAtrrVal) / 100;
                if (productPrice >= currentMinPrice && productPrice <= currentMaxPrice) {
                    filteredByPriceArray.push(productsArray[i]);
                }
            }
            return filteredByPriceArray;
        }

        function pageClickHandler(event, el) {
            event.preventDefault();
            var isPagination = true;
            var parent = $(el).parent();
            var isPageNum = parent.hasClass('page-num');
            var isPageArrow = parent.hasClass('page-arrow');
            renderBool = false;

            if (parent.hasClass('current') || parent.hasClass('deco')) {
                return;
            } else {

                if (isPageNum) {
                    var pageNum = Number($(el).text().trim());
                    $('#pagination .current').removeClass('current');
                    parent.addClass('current');
                } else if (isPageArrow && parent.hasClass('next')) {
                    var pageNum = +$(el).parent('span').siblings('.current').text().trim() + 1;
                    // check if next element is not three dots element ...
                    if (!$(el).parent('span').siblings('.current').next().hasClass('deco')
                        && !$(el).parent('span').siblings('.current').next().hasClass('next')) {
                        var nextNum = $(el).parent('span').siblings('.current').next();
                        $('#pagination .current').removeClass('current');
                        nextNum.addClass('current');
                    } else {
                        renderBool = true;
                    }
                } else if (isPageArrow && parent.hasClass('prev')) {
                    var pageNum = +$(el).parent('span').siblings('.current').text().trim() - 1;
                    // check if prev element is not three dots element ...
                    if (!$(el).parent('span').siblings('.current').prev().hasClass('deco')
                        && !$(el).parent('span').siblings('.current').prev().hasClass('prev')) {
                        var prevNum = $(el).parent('span').siblings('.current').prev();
                        $('#pagination .current').removeClass('current');
                        prevNum.addClass('current');
                    } else {
                        renderBool = true;
                    }
                }

                isPageClick = true;

                if (parent.hasClass('last')) {
                    parent.siblings('.next').hide();
                    if (parent.siblings('.prev').css('display') == 'none') {
                        parent.siblings('.prev').show();
                    }
                } else if (parent.hasClass('first')) {
                    parent.siblings('.prev').hide();
                    if (parent.siblings('.next').css('display') == 'none') {
                        parent.siblings('.next').show();
                    }
                } else if (parent.hasClass('mid')) {
                    parent.siblings('.prev, .next').show();
                }

                if ($('#pagination span.first').hasClass('current') && $('#pagination span.first a').text().trim() == 1) {
                    $('#pagination span.prev').hide();
                } else if ($('#pagination span.last').hasClass('current')) {
                    $('#pagination span.next').hide();
                } else {
                    $('#pagination span.prev, #pagination span.next').show();
                }

                showSpinner();

                getArrayOfAllProducts(htmlSplitter, isPagination, pageNum);
            }
        }

        function getFilterTagOption(elem) {
            var filterPrefix = elem.parent('li').parent('ul.accordion-body').attr('data-tag');
            var filterOption = elem.text().toLowerCase().trim().split(' ').join(' ');
            return filterPrefix + '-' + filterOption;
        }

        function getFilteredProducts(productsArray, filterObj) {
            var dataTag = '';
            var tagValue = '';
            var filteredArray = [];
            var count = 0;
            var numberOfArrays = 0;
            var indexStr = ',';
            for (var i = 0; i < productsArray.length; i++) {
                count = 0;
                numberOfArrays = 0;

                for (var key in filterObj) {
                    if (filterObj.hasOwnProperty(key) && filterObj[key].length !== 0) {
                        numberOfArrays++;
                        indexStr = ',';

                        // get name of data attribute e.g. 'data-region'
                        dataTag = 'data-' + key;
                        for (var z = 0; z < filterObj[key].length; z++) {
                            // get filter option value e.g. 'barossa-valley-sa' or 'france'
                            tagValue = filterObj[key][z].substr(filterObj[key][z].indexOf('-') + 1);

                            // if there is such data attribute in html string
                            if (productsArray[i].indexOf(dataTag) > -1) {
                                var endPosition = productsArray[i].indexOf(dataTag) + dataTag.length + 1;
                                var lastAttrPosition = endPosition + productsArray[i].slice(endPosition).indexOf("?endData");

                                // get value of appropriate data attribute from HTML string // array ['france'] or ['france','new-zealand']
                                var tagValuesArr = productsArray[i].slice(endPosition + 1, lastAttrPosition).split(',');

                                if (tagValuesArr.length == 1) {
                                    if (tagValue == tagValuesArr[0] || tagValue == tagValuesArr[0] + 's') {
                                        if (indexStr.indexOf(',' + i + ',') == -1) {
                                            count++;
                                            indexStr = indexStr + i + ',';
                                            break;
                                        }
                                    }
                                } else {
                                    for (var c = 0; c < tagValuesArr.length; c++) {
                                        if (tagValue == tagValuesArr[c] || tagValue == tagValuesArr[c] + 's') {
                                            if (indexStr.indexOf(',' + i + ',') == -1) {
                                                count++;
                                                indexStr = indexStr + i + ',';
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (numberOfArrays === count) {
                    filteredArray.push(productsArray[i]);
                }
                numberOfArrays = 0;
            }
            return filteredArray;
        }


        // LAZY LOADING START
        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }

        function _iterableToArray(iter) {
            if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
                    arr2[i] = arr[i];
                }
                return arr2;
            }
        }

        function lazyLoad(data) {
            data.forEach(function (image) {
                image.src = image.dataset.src;
                image.onload = function () {
                    image.classList.add('loaded');
                };
            });
        }
        // LAZY LOADING END

        function filterProducts(prodArr, container, isPagination, currentPage) {

            var toFilter = false;
            for (key in collectionFilters) {
                if (collectionFilters.hasOwnProperty(key)) {
                    if (collectionFilters[key].length > 0) {
                        toFilter = true;
                        break;
                    }
                }
            }
            if (toFilter) {
                prodArr = getFilteredProducts(prodArr, collectionFilters);
                productsPageQty = prodArr.length;
            }
            if (isPriceFilter) {
                prodArr = filterByPrice(prodArr, 'data-price');
                productsPageQty = prodArr.length;
            }
            allProductsQty = prodArr.length;
            if (isPagination && prodArr.length > paginateValue) {
                prodArr = paginateProducts(prodArr, currentPage);
                productsPageQty = prodArr.length;
            }
            if (!isPriceFilter && !isPagination) {
                productsPageQty = allProductsQty;
            }
            container.html(prodArr);
            setTimeout(function () {
                spinnerWrapper.addClass('hidden');
                // Lazy load
                var lazyImages = _toConsumableArray(document.querySelectorAll('.lazy-image'));
                lazyLoad(lazyImages);
            }, 200);
            if ((isPagination && !isPageClick) || renderBool) {
                updatePagination(productsPageQty, allProductsQty, currentPage);
            }
            updateProductsQty(productsPageQty, allProductsQty);

        }

        function getArrayOfAllProducts(splitter, isPagination, currentPageNum) {
            var allProducts = [];

            function getAllProducts(count, pagesQty) {
                $.when($.get(url + '?view=nolayout' + '&page=' + count + '&req=' + $.now() + '&sort_by=' + sortSelect.val()))
                    .then(function (data) {
                        var productsDataArr = data.split(splitter).map(cleanSpacesInArrayItem).filter(removeEmptyArrayItem);
                        allProducts = allProducts.concat(productsDataArr);
                        if (count < pagesQty) {
                            getAllProducts(++count, pagesQty);
                        } else {
                            filterProducts(allProducts, $container, isPagination, currentPageNum);
                        }
                    });
            }

            $.when($.getJSON(url))
                .then(function (dataCount) {
                    var productsTotal = +dataCount.collection.products_count;
                    if (productsTotal <= limit) {
                        $.when($.get(url + '?view=nolayout' + '&sort_by=' + sortSelect.val()))
                            .then(function (data) {
                                allProducts = data.split(splitter).map(cleanSpacesInArrayItem).filter(removeEmptyArrayItem);
                                filterProducts(allProducts, $container, isPagination, currentPageNum);
                            });
                    } else {
                        var pages = 0;
                        if (productsTotal % limit === 0) {
                            pages = productsTotal / limit;
                        } else {
                            pages = Math.floor(productsTotal / limit) + 1;
                        }
                        var count = 1;
                        getAllProducts(count, pages);
                    }
                });
        }

        function showSpinner() {
            var collWrapper = $('#coll-products-wrapper-id');
            var spinnerLeftCoord = collWrapper.offset().left + collWrapper.width() / 2 - 36;
            var spinnerTopCoord = 0;
            if ($(window).scrollTop() > collWrapper.offset().top) {
                spinnerTopCoord = '30%';
            } else {
                spinnerTopCoord = collWrapper.offset().top - $(window).scrollTop() + 50;
            }
            spinner.css({
                'left': spinnerLeftCoord,
                'top': spinnerTopCoord
            });
            spinnerWrapper.removeClass('hidden');
        }


        // call functions

        createPropertiesForCollectionFilter();

        getMaxPrice();

        $slider.slider({
            range: true,
            min: minPrice,
            max: maxPrice,
            step: 5,
            values: [minPrice, maxPrice],
            start: function (event, ui) {
                currentMinPrice = currentMinPrice != ui.values[0] ? ui.values[0] : currentMinPrice;
                currentMaxPrice = currentMaxPrice != ui.values[1] ? ui.values[1] : currentMaxPrice;
            },
            slide: function (event, ui) {
                var setPricesPositions = function () {
                    minSliderPrice.html(slate.Currency.formatMoney(Currency.convert($slider.slider('values', 0) * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('')).position({
                        my: 'left',
                        at: 'left',
                        of: $('.ui-slider-handle:eq(0)')
                    });
                    maxSliderPrice.html(slate.Currency.formatMoney(Currency.convert($slider.slider('values', 1) * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join('')).position({
                        my: 'right',
                        at: 'right',
                        of: $('.ui-slider-handle:eq(1)')
                    });
                    //set values in hidden element
                    $('.slider-values .min-value').html(slate.Currency.formatMoney(Currency.convert($slider.slider('values', 0) * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join(''));
                    $('.slider-values .max-value').html(slate.Currency.formatMoney(Currency.convert($slider.slider('values', 1) * 100, Currency.storeNativeCurrency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format).split('"').join(''));
                    bothSliderPrices.position({
                        my: 'left',
                        at: 'left',
                        of: $('.ui-slider-handle').eq(0)
                    });
                    showHiddenValues(minSliderPrice, maxSliderPrice, bothSliderPrices, $('#price-slider'));
                };
                setTimeout(setPricesPositions, 5);
            },
            stop: function (event, ui) {
                if (ui.values[0] != currentMinPrice || ui.values[1] != currentMaxPrice) {
                    currentMinPrice = ui.values[0];
                    currentMaxPrice = ui.values[1];
                    if (currentMinPrice != minPrice || currentMaxPrice != maxPrice) {
                        clearBtn.removeClass('hidden');
                    } else {
                        if (!clearBtn.hasClass('hidden')) {
                            clearBtn.addClass('hidden');
                            // update for non transactional
                            if (window.location.host === 'nudebynature.com.au' || window.location.host === 'nudebynature.co.nz') {
                                setSliderMinMax();
                            }
                        }
                    }
                    isPriceFilter = true;
                    var isPagination = $('#pagination').length;
                    isPageClick = false;
                    showSpinner();
                    getArrayOfAllProducts(htmlSplitter, isPagination);
                } else {
                    return;
                }
            }
        });


        clearBtn.on('click', function (e) {
            e.preventDefault();
            // Comment out for non-transactional
            setSliderMinMax();
            if (bothSliderPrices.hasClass('visible')) {
                bothSliderPrices.css({'visibility': 'hidden', 'opacity': '0'}).removeClass('visible');
                $('.slider-values.min-value, .slider-values.max-value').css({'visibility': 'visible', 'opacity': '1'});
            }
            $slider.slider('values', [minPrice, maxPrice]);
            currentMinPrice = minPrice;
            currentMaxPrice = maxPrice;
            //TODO  to optimize
            var isPagination = $('#pagination').length;
            isPageClick = false;
            showSpinner();
            getArrayOfAllProducts(htmlSplitter, isPagination);
            $(this).addClass('hidden');
        });

        $('.filter-link').on('click', function (event) {
            event.preventDefault();
            var parent = $(event.target).is('a') ? $(event.target).parent('li') : $(event.target).parent('a').parent('li');

            var isActive = parent.hasClass('active');
            var isAllLink = $(this).hasClass('all-filters');
            var isAllCollection = $(this).hasClass('all-collection');
            var allLinkItem = parent.parent().find('.all-filters').parent('li');
            var isPagination = $('#pagination').length;

            isPageClick = false;
            isSingleOption = false;

            var filterName = $(this).parent('li').parent('ul.accordion-body').attr('data-tag');

            if (isAllCollection) {
                $('.filter-link').parent('.active').removeClass('active');
                for (var key in collectionFilters) {
                    if (collectionFilters.hasOwnProperty(key) && collectionFilters[key].length !== 0) {
                        collectionFilters[key] = [];
                    }
                }

            } else if (isAllLink) {

                if (isActive) {
                    parent.removeClass('active');
                    collectionFilters[filterName] = [];

                } else {
                    parent.addClass('active');
                    parent.siblings('li.active').removeClass('active');

                    collectionFilters[filterName] = [];
                    collectionFilters[filterName] = collectionFilters[filterName].concat(parseAllLinks(parent.siblings('li').find('.filter-link')));
                }
                // if tag filter link (not 'all') is clicked
            } else {
                // check if 'ALL' is active
                if (allLinkItem.hasClass('active')) {
                    allLinkItem.removeClass('active');
                    collectionFilters[filterName] = [];
                }

                if (isActive) {
                    parent.removeClass('active');

                    collectionFilters[filterName] = collectionFilters[filterName].filter(removeLinkFromArray, $(this));

                } else {
                    if (allLinkItem.hasClass('active')) {
                        allLinkItem.removeClass('active');
                    }

                    parent.addClass('active');
                    collectionFilters[filterName].push(getFilterTagOption($(this)));

                }
            }

            var currentPage = 1;
            showSpinner();
            getArrayOfAllProducts(htmlSplitter, isPagination, currentPage);

            //}

        });

        $('#sort-select').on('change', function () {
            var isPagination = $('#pagination').length;
            isPageClick = false;
            showSpinner();
            getArrayOfAllProducts(htmlSplitter, isPagination);
        });

        $('#pagination a').on('click', function (event) {
            pageClickHandler(event, $(this));
        });


        // if (getParameterByName('skintone')) {
        //   var skintone = getParameterByName('skintone');
        //   $('#skin-filter-' + skintone).trigger('click');
        // }

    }

});

/*
	Custom script, which can be used in different templates
*/
$(document).ready(function() {

  var rte = $('.rte');

  // Scroll to top link functionality

  $('#scroll-top').click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  // Remove empty paragraphs from .rte content

  if (rte.length) {
    var paragraph = rte.find('p');
    for (var i = 0; i < paragraph.length; i++) {
      if (!(/\S/.test(paragraph.eq(i).text())) && paragraph.eq(i).children().length < 1) {
        paragraph.eq(i).css({
          'margin' : '0',
          'padding' : '0'
        });
      }
    }
  }

});
/*
	Search form functionality
*/
$(document).ready(function() {

	var searchBtn = $('.top .search-btn');
	var searchLabel = $('.top .search-label');
	var searchField = $('.top .search-field');
	var closeIcon = $('.top .close-x');
	var mobileCloseIcon = $('.top .close-x-mobile');
	var searchFormWrapper = $('.top.search-wrapper');
	var widthCut = 767;

	function openSearchForm(formWrapper, className) {

		if ($(window).width() > widthCut)
			formWrapper.addClass(className);
	}

	function closeSearchForm(formWrapper, className) {

		if ($(window).width() > widthCut)
			formWrapper.removeClass(className);
	}

	searchLabel.on('click', function () {
			openSearchForm(searchFormWrapper, 'expanded');
	});

	searchBtn.on('click', function (event) {
		if ( (searchField.val() === '') || (!searchFormWrapper.hasClass('expanded')) && ($(window).width() > widthCut) ) {
			event.preventDefault(event);
			openSearchForm(searchFormWrapper, 'expanded');
		}

		if ( (searchField.val() === '') && ($(window).width() <= widthCut) ) {
			event.preventDefault(event);
			searchField.focus();
		}
	});

	closeIcon.on('click', function () {
			closeSearchForm(searchFormWrapper, 'expanded');
	});

	mobileCloseIcon.on('click', function () {
			searchField.val('');
	});

	if ($('.search-page').length) {
		$('.search-page-form .search-btn').on('click', function(event) {
			var value = $(this).siblings('#Search').val();
			if (!(/\S/.test(value))) {
				event.preventDefault();
			}
		});
	}

});

/*
	Fixed navigation functionality
*/
$(document).ready(function () {

  var $window = $(window),
    $productPage = $('#product-page'),
    $navigation = $('#navigation'),
    $header = $('.header'),
    navTop = $navigation.offset().top;

  function setStickyElement($elem, elemTopCoordinate, classNameSticky, $headerElem) {
    var windowScroll = $(window).scrollTop();
    if (windowScroll > elemTopCoordinate) {
      $elem.addClass(classNameSticky);
      $headerElem.css('margin-bottom', $elem.height() + 'px');
      hideSearchOnSticky();
      addScrollspy();
      // hotfix for brush bar stick navigation
      if (window.location.pathname === "/pages/brush-bar" && !!document.querySelector("#bb-back")) {
        $('#bb-back').addClass('bb-sticky-back');
      }
    } else if (windowScroll < elemTopCoordinate && $elem.hasClass(classNameSticky)) {
      $headerElem.css('margin-bottom', '');
      $elem.removeClass(classNameSticky);
      removeScrollspy();
      showSearchOnSticky();
      // hotfix for brush bar stick navigation
      if (window.location.pathname === "/pages/brush-bar" && !!document.querySelector("#bb-back")) {
        $('#bb-back').removeClass('bb-sticky-back');
      }
    }
  }

  // brush bar hotfix
  function setBrushBarStickyBack($elem, elemTopCoordinate, classNameSticky) {
    var windowScroll = $(window).scrollTop();
    if ($window.width() > 767) {
      if (windowScroll > elemTopCoordinate) {
        $elem.addClass(classNameSticky);
      } else if (windowScroll < elemTopCoordinate && $elem.hasClass(classNameSticky)) {
        $elem.removeClass(classNameSticky);
      }
    } else {
      if (windowScroll > 10) {
        $elem.addClass(classNameSticky);
      } else if (windowScroll <= 10 && $elem.hasClass(classNameSticky)) {
        $elem.removeClass(classNameSticky);
      }
    }
  }

  function addScrollspy() {
    if ($productPage.length) {
      var offset = $('#navigation').height() + $('#wrapper-for-stick').height();
      $('body').attr('data-offset', offset);
    }
  }

  function removeScrollspy() {
    $('body').attr('data-offset', null);
  }

  function hideSearchOnSticky() {
    if (window.location.host === 'nudebynature.fr' || window.location.host === 'fr.nudebynature.ca' || window.location.host === 'nudebynature.de' || window.location.host === 'nudebynature.pl') {
      $('.search-wrapper').hide()
    }
  }

  function showSearchOnSticky() {
    if (window.location.host === 'nudebynature.fr' || window.location.host === 'fr.nudebynature.ca' || window.location.host === 'nudebynature.de' || window.location.host === 'nudebynature.pl') {
      $('.search-wrapper').show()
    }
  }

  $window.on('scroll orientationchange resize', function (event) {
    if ($window.width() > 767) {
      setStickyElement($navigation, navTop, 'navbar-fixed-top', $header);
    } else {
      $header.css('margin-bottom', '');
    }

    // hotfix for the brushbar back
    if (window.location.pathname === "/pages/brush-bar" && !!document.querySelector("#bb-back")) {
      setBrushBarStickyBack($('#bb-back'), navTop, 'bb-sticky-back')
    }
  });

});

function moveToElementPositionWithOffset(element) {
  var headerOffset = $('.wrapper-for-stick').height() + $('#navbar').height();
  $('html,body').animate({
    scrollTop: $(element).offset().top - headerOffset
  });
}

$(document).ready(function() {
  var $window = $(window);

  //make stockists navbar sticky on scroll
  if ($('#sticky-nav').length > 0 && $window.width() > 767) {

    var $stickyNav = $('#sticky-nav');
    var $stockistsColumn = $('#stockists-col');
    var stockistTop = $stickyNav.offset().top;
    var $footer = $('.footer');
    var fixedHeaderNavbar = $('#navigation');
    var fixedQualifiers = $('#wrapper-for-stick');
    
    function stickyRelocate() {
      var stockistWidth = $stockistsColumn.width() + 'px';
      var windowTop = $window.scrollTop();
      var stickyNavHeight = $stickyNav.outerHeight();
      var footerTop = $footer.offset().top;
      var fixedHeaderElementsHeight = fixedHeaderNavbar.height() + fixedQualifiers.height() + 2;
      var topPosition = windowTop + fixedHeaderElementsHeight;
      var navBottom = topPosition + stickyNavHeight;

      if (topPosition >= stockistTop) {
        $stickyNav.addClass('stick-stockists');
        $stickyNav.css('top', fixedHeaderElementsHeight + 'px');
        $stickyNav.css('width', stockistWidth);
        if (navBottom >= footerTop) {
          var coordinate = -(stickyNavHeight - (footerTop - windowTop)) + 'px';
          $stickyNav.css({'top': coordinate});
        } else {
          $stickyNav.css('top', fixedHeaderElementsHeight + 'px');
        }
      } else {
        $stickyNav.removeClass('stick-stockists');
        $stickyNav.css('width', 'auto');
        $stickyNav.css('top', '');
      }
    }

    stickyRelocate();
    $window.on('scroll resize orientationchange', function(){
      stickyRelocate();
    });

  } else { 
    return;
  }

});

/*=============== Custom Code ================*/
/**
 * Preforms a regex check of an email address against blacklisted email address
 * @param {string} email - Email address to check
 * @return {boolean} - Coerces the regex result to a boolean to be either true or false
 */
function blacklistedDomains(email) {
    return !!email.match(/(126.com|139.cm|139.com|139.net|163.com|7777.com|pp.com|qq.com|sina.com)$/);
}

/**
 * Sets cookie value on the browser
 * https://stackoverflow.com/questions/1458724/how-do-i-set-unset-a-cookie-with-jquery
 * @param {string} key - Data key
 * @param {string} value - Data value attached to key
 * @param {int} expireDays - Number of days until cookie expires
 */
function setCookie(key, value, expireDays) {
    if (typeof expireDays === 'undefined') {
        var expireDays = 0;
    }

    if (expireDays === -1) {
        document.cookie = key + "=" + value + "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    if (expireDays > 0) {
        // Set a cookie that expires, this is set to 24 hour time
        var expires = new Date();
        expires.setTime(expires.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        expires = ";expires=" + expires.toUTCString();
        document.cookie = key + '=' + value + expires + ';path=/';
    }
    else {
        // Set a session only cookie
        document.cookie = key + '=' + value + ';expires=0;path=/';
    }
}

/**
 * Retrieve cookie data
 * @param {string} key - Cookie name
 * @return - Returns data of cookie key or null
 */
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

/**
 * Deletes a cookie and its data
 * @param {string} key - Cookie name
 */
function eraseCookie(key) {
    document.cookie = key + '=; Max-Age=0'
}


function nbnPushDataLayerEvent(event) {
    if (getCookie("nbn-user-events") != null) {
        var dataLayerEvents = JSON.parse(getCookie("nbn-user-events"));
        if (whatIsIt(dataLayerEvents === "Object")) {
            dataLayerEvents.push(event);
            setCookie("nbn-user-events", JSON.stringify(dataLayerEvents), 0);
        }

    }
    else
        setCookie("nbn-user-events", JSON.stringify(event), 0);
}

/**
 * Checkes and returns the object type
 * @param {object} object - The object to check the type of
 * @return {string} - The object type
 */
function whatIsIt(object) {
    if (object === null) {
        return "null";
    }
    else if (object === undefined) {
        return "undefined";
    }
    else if (object.constructor === String().constructor) {
        return "String";
    }
    else if (object.constructor === Number().constructor) {
        return "Number";
    }
    else if (object.constructor === Boolean().constructor) {
        return "Boolean";
    }
    else if (object.constructor === Array().constructor) {
        return "Array";
    }
    else if (object.constructor === Object.constructor) {
        return "Object";
    }
    else {
        return "UNKNOWN";
    }
}

/**
 * Sets the cookie for user preferences
 * @param {string} values - The data to be stored in the preferences cookie
 */
function prefSuccess(values) {
    setCookie('nbn-preferences', values, 3650);
    $('#pref-modal').modal('hide')
}

/**
 * Handles the cart data calls to the data layer, Segment etc.
 * Check additional-cart.js for more info.
 * additional-cart.js handles the AJAX jQuery for the cart events, the cart data
 * @param cart - Current cart data
 * @param {string} label - Event name
 */
function nbnCartSegment(cart, label) {
    // Currently only fired on product page for add to cart because javascript errors with the way the item is populated for other pages and events
    var data = {
        "event": convertToSlug(label),
        "site": window.location.hostname.split('.')[3] || window.location.hostname.split('.')[2],
        "language": navigator.language,
        "user": {
            "id": window.custInfo.customer,
            "email": window.custInfo.email,
            "points": ""
        },
        "cart": cart,
        "page": {
            "type": "home",
            "title": window.pageData.title,
            "name": window.pageData.name,
            "url": window.location.href
        }
    };
    window.dataLayer.push(data);
    if (checkHost(window.location.host) && check_ga()) {
        ga('ec:addProduct', {
            'id': window.productData.product_id,
            'name': window.productData.item.name,
            'price': window.productData.item.price
        });
        ga('ec:setAction', 'add');
        ga('send', 'event', 'cart', 'change', convertToSlug(label));
    }
}

/**
 * Replaces the spaces in a string with hyphens
 * @param {string} text
 * @return {string} - Hyphenated string
 */
function convertToSlug(text) {
    return text
        .toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}


/**
 * Countdown timer for the product page
 * @param {string} date_string - Finish date of the timer
 * @param {string} page - Page the timer is one
 * @param {string} element - The element the timer is in
 * @param {string} element2 - The element the end message is in
 * @param {string} message - The end message to display
 */
function countdownTimer(date_string, page, element, element2, message) {
    // Set the date the countdown finishes
    var finish_date = new Date(date_string).getTime();

    // Update the countdown every 1 second
    var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now an the count down date
        var distance = finish_date - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var time_remaining = days + "D " + hours + "H " + minutes + "M " + seconds + "S";

        // Output in the right format for the right page
        if (page === "product") {
            document.querySelector(element).innerHTML = time_remaining;

            // If the count down is over...
            if (distance < 0) {
                clearInterval(x);
                document.querySelector(element2).innerHTML = message;
            }
        }
    }, 1000);
}

/**
 * Checks to see if Google Analytics has fired on page
 * @return {boolean}
 */
function check_ga() {
    // could use (typeof ga !== "undefined")
    return typeof ga === 'function';
}

/**
 * Checks if a host is approved or not
 * @param {string} host - The page host to check
 * @return {boolean}
 */
function checkHost(host) {
    var approvedHosts = ['nudebynature.com', 'nudebynature.co.uk', 'nudebynature.eu', 'nudebynature.fr', 'fr.nudebynature.ca', 'nudebynature.de', 'nudebynature.pl'];
    return (approvedHosts.indexOf(host) > -1);
}

/**
 * Page scroller
 * @param {string|int} id - The id of the element to scroll to
 */
function scrollToId(id) {
    $(document).scrollTo($('#' + id), 500, {offset: {top:-60}})
}

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */ 

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function(currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function() {
    return jQuery.cookie(this.name);
  },
  destroy: function() {
    jQuery.cookie(this.name, null, this.configuration);
  }
};

Currency.moneyFormats = {
  "USD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} USD"
  },
  "EUR":{
    "money_format":"&euro;{{amount}}",
    "money_with_currency_format":"&euro;{{amount}} EUR"
  },
  "GBP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} GBP"
  },
  "CAD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} CAD"
  },
  "ALL":{
    "money_format":"Lek {{amount}}",
    "money_with_currency_format":"Lek {{amount}} ALL"
  },
  "DZD":{
    "money_format":"DA {{amount}}",
    "money_with_currency_format":"DA {{amount}} DZD"
  },
  "AOA":{
    "money_format":"Kz{{amount}}",
    "money_with_currency_format":"Kz{{amount}} AOA"
  },
  "ARS":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} ARS"
  },
  "AMD":{
    "money_format":"{{amount}} AMD",
    "money_with_currency_format":"{{amount}} AMD"
  },
  "AWG":{
    "money_format":"Afl{{amount}}",
    "money_with_currency_format":"Afl{{amount}} AWG"
  },
  "AUD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} AUD"
  },
  "BBD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} Bds"
  },
  "AZN":{
    "money_format":"m.{{amount}}",
    "money_with_currency_format":"m.{{amount}} AZN"
  },
  "BDT":{
    "money_format":"Tk {{amount}}",
    "money_with_currency_format":"Tk {{amount}} BDT"
  },
  "BSD":{
    "money_format":"BS${{amount}}",
    "money_with_currency_format":"BS${{amount}} BSD"
  },
  "BHD":{
    "money_format":"{{amount}}0 BD",
    "money_with_currency_format":"{{amount}}0 BHD"
  },
  "BYR":{
    "money_format":"Br {{amount}}",
    "money_with_currency_format":"Br {{amount}} BYR"
  },
  "BZD":{
    "money_format":"BZ${{amount}}",
    "money_with_currency_format":"BZ${{amount}} BZD"
  },
  "BTN":{
    "money_format":"Nu {{amount}}",
    "money_with_currency_format":"Nu {{amount}} BTN"
  },
  "BAM":{
    "money_format":"KM {{amount_with_comma_separator}}",
    "money_with_currency_format":"KM {{amount_with_comma_separator}} BAM"
  },
  "BRL":{
    "money_format":"R$ {{amount_with_comma_separator}}",
    "money_with_currency_format":"R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB":{
    "money_format":"Bs{{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP":{
    "money_format":"P{{amount}}",
    "money_with_currency_format":"P{{amount}} BWP"
  },
  "BND":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} BND"
  },
  "BGN":{
    "money_format":"{{amount}} лв",
    "money_with_currency_format":"{{amount}} лв BGN"
  },
  "MMK":{
    "money_format":"K{{amount}}",
    "money_with_currency_format":"K{{amount}} MMK"
  },
  "KHR":{
    "money_format":"KHR{{amount}}",
    "money_with_currency_format":"KHR{{amount}}"
  },
  "KYD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} KYD"
  },
  "XAF":{
    "money_format":"FCFA{{amount}}",
    "money_with_currency_format":"FCFA{{amount}} XAF"
  },
  "CLP":{
    "money_format":"${{amount_no_decimals}}",
    "money_with_currency_format":"${{amount_no_decimals}} CLP"
  },
  "CNY":{
    "money_format":"&#165;{{amount}}",
    "money_with_currency_format":"&#165;{{amount}} CNY"
  },
  "COP":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} COP"
  },
  "CRC":{
    "money_format":"&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format":"&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK":{
    "money_format":"{{amount_with_comma_separator}} kn",
    "money_with_currency_format":"{{amount_with_comma_separator}} kn HRK"
  },
  "CZK":{
    "money_format":"{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format":"{{amount_with_comma_separator}} K&#269;"
  },
  "DKK":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"kr.{{amount_with_comma_separator}}"
  },
  "DOP":{
    "money_format":"RD$ {{amount}}",
    "money_with_currency_format":"RD$ {{amount}}"
  },
  "XCD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"EC${{amount}}"
  },
  "EGP":{
    "money_format":"LE {{amount}}",
    "money_with_currency_format":"LE {{amount}} EGP"
  },
  "ETB":{
    "money_format":"Br{{amount}}",
    "money_with_currency_format":"Br{{amount}} ETB"
  },
  "XPF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"FJ${{amount}}"
  },
  "GMD":{
    "money_format":"D {{amount}}",
    "money_with_currency_format":"D {{amount}} GMD"
  },
  "GHS":{
    "money_format":"GH&#8373;{{amount}}",
    "money_with_currency_format":"GH&#8373;{{amount}}"
  },
  "GTQ":{
    "money_format":"Q{{amount}}",
    "money_with_currency_format":"{{amount}} GTQ"
  },
  "GYD":{
    "money_format":"G${{amount}}",
    "money_with_currency_format":"${{amount}} GYD"
  },
  "GEL":{
    "money_format":"{{amount}} GEL",
    "money_with_currency_format":"{{amount}} GEL"
  },
  "HNL":{
    "money_format":"L {{amount}}",
    "money_with_currency_format":"L {{amount}} HNL"
  },
  "HKD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"HK${{amount}}"
  },
  "HUF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr ISK"
  },
  "INR":{
    "money_format":"Rs. {{amount}}",
    "money_with_currency_format":"Rs. {{amount}}"
  },
  "IDR":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"Rp {{amount_with_comma_separator}}"
  },
  "ILS":{
    "money_format":"{{amount}} NIS",
    "money_with_currency_format":"{{amount}} NIS"
  },
  "JMD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} JMD"
  },
  "JPY":{
    "money_format":"&#165;{{amount_no_decimals}}",
    "money_with_currency_format":"&#165;{{amount_no_decimals}} JPY"
  },
  "JEP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} JEP"
  },
  "JOD":{
    "money_format":"{{amount}}0 JD",
    "money_with_currency_format":"{{amount}}0 JOD"
  },
  "KZT":{
    "money_format":"{{amount}} KZT",
    "money_with_currency_format":"{{amount}} KZT"
  },
  "KES":{
    "money_format":"KSh{{amount}}",
    "money_with_currency_format":"KSh{{amount}}"
  },
  "KWD":{
    "money_format":"{{amount}}0 KD",
    "money_with_currency_format":"{{amount}}0 KWD"
  },
  "KGS":{
    "money_format":"лв{{amount}}",
    "money_with_currency_format":"лв{{amount}}"
  },
  "LVL":{
    "money_format":"Ls {{amount}}",
    "money_with_currency_format":"Ls {{amount}} LVL"
  },
  "LBP":{
    "money_format":"L&pound;{{amount}}",
    "money_with_currency_format":"L&pound;{{amount}} LBP"
  },
  "LTL":{
    "money_format":"{{amount}} Lt",
    "money_with_currency_format":"{{amount}} Lt"
  },
  "MGA":{
    "money_format":"Ar {{amount}}",
    "money_with_currency_format":"Ar {{amount}} MGA"
  },
  "MKD":{
    "money_format":"ден {{amount}}",
    "money_with_currency_format":"ден {{amount}} MKD"
  },
  "MOP":{
    "money_format":"MOP${{amount}}",
    "money_with_currency_format":"MOP${{amount}}"
  },
  "MVR":{
    "money_format":"Rf{{amount}}",
    "money_with_currency_format":"Rf{{amount}} MRf"
  },
  "MXN":{
    "money_format":"$ {{amount}}",
    "money_with_currency_format":"$ {{amount}} MXN"
  },
  "MYR":{
    "money_format":"RM{{amount}} MYR",
    "money_with_currency_format":"RM{{amount}} MYR"
  },
  "MUR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} MUR"
  },
  "MDL":{
    "money_format":"{{amount}} MDL",
    "money_with_currency_format":"{{amount}} MDL"
  },
  "MAD":{
    "money_format":"{{amount}} dh",
    "money_with_currency_format":"Dh {{amount}} MAD"
  },
  "MNT":{
    "money_format":"{{amount_no_decimals}} &#8366",
    "money_with_currency_format":"{{amount_no_decimals}} MNT"
  },
  "MZN":{
    "money_format":"{{amount}} Mt",
    "money_with_currency_format":"Mt {{amount}} MZN"
  },
  "NAD":{
    "money_format":"N${{amount}}",
    "money_with_currency_format":"N${{amount}} NAD"
  },
  "NPR":{
    "money_format":"Rs{{amount}}",
    "money_with_currency_format":"Rs{{amount}} NPR"
  },
  "ANG":{
    "money_format":"&fnof;{{amount}}",
    "money_with_currency_format":"{{amount}} NA&fnof;"
  },
  "NZD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} NZD"
  },
  "NIO":{
    "money_format":"C${{amount}}",
    "money_with_currency_format":"C${{amount}} NIO"
  },
  "NGN":{
    "money_format":"&#8358;{{amount}}",
    "money_with_currency_format":"&#8358;{{amount}} NGN"
  },
  "NOK":{
    "money_format":"kr {{amount_with_comma_separator}}",
    "money_with_currency_format":"kr {{amount_with_comma_separator}} NOK"
  },
  "OMR":{
    "money_format":"{{amount_with_comma_separator}} OMR",
    "money_with_currency_format":"{{amount_with_comma_separator}} OMR"
  },
  "PKR":{
    "money_format":"Rs.{{amount}}",
    "money_with_currency_format":"Rs.{{amount}} PKR"
  },
  "PGK":{
    "money_format":"K {{amount}}",
    "money_with_currency_format":"K {{amount}} PGK"
  },
  "PYG":{
    "money_format":"Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN":{
    "money_format":"S/. {{amount}}",
    "money_with_currency_format":"S/. {{amount}} PEN"
  },
  "PHP":{
    "money_format":"&#8369;{{amount}}",
    "money_with_currency_format":"&#8369;{{amount}} PHP"
  },
  "PLN":{
    "money_format":"{{amount_with_comma_separator}} zl",
    "money_with_currency_format":"{{amount_with_comma_separator}} zl PLN"
  },
  "QAR":{
    "money_format":"QAR {{amount_with_comma_separator}}",
    "money_with_currency_format":"QAR {{amount_with_comma_separator}}"
  },
  "RON":{
    "money_format":"{{amount_with_comma_separator}} lei",
    "money_with_currency_format":"{{amount_with_comma_separator}} lei RON"
  },
  "RUB":{
    "money_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF":{
    "money_format":"{{amount_no_decimals}} RF",
    "money_with_currency_format":"{{amount_no_decimals}} RWF"
  },
  "WST":{
    "money_format":"WS$ {{amount}}",
    "money_with_currency_format":"WS$ {{amount}} WST"
  },
  "SAR":{
    "money_format":"{{amount}} SR",
    "money_with_currency_format":"{{amount}} SAR"
  },
  "STD":{
    "money_format":"Db {{amount}}",
    "money_with_currency_format":"Db {{amount}} STD"
  },
  "RSD":{
    "money_format":"{{amount}} RSD",
    "money_with_currency_format":"{{amount}} RSD"
  },
  "SCR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} SCR"
  },
  "SGD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} SGD"
  },
  "SYP":{
    "money_format":"S&pound;{{amount}}",
    "money_with_currency_format":"S&pound;{{amount}} SYP"
  },
  "ZAR":{
    "money_format":"R {{amount}}",
    "money_with_currency_format":"R {{amount}} ZAR"
  },
  "KRW":{
    "money_format":"&#8361;{{amount_no_decimals}}",
    "money_with_currency_format":"&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} LKR"
  },
  "SEK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr SEK"
  },
  "CHF":{
    "money_format":"SFr. {{amount}}",
    "money_with_currency_format":"SFr. {{amount}} CHF"
  },
  "TWD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TWD"
  },
  "THB":{
    "money_format":"{{amount}} &#xe3f;",
    "money_with_currency_format":"{{amount}} &#xe3f; THB"
  },
  "TZS":{
    "money_format":"{{amount}} TZS",
    "money_with_currency_format":"{{amount}} TZS"
  },
  "TTD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TTD"
  },
  "TND":{
    "money_format":"{{amount}}",
    "money_with_currency_format":"{{amount}} DT"
  },
  "TRY":{
    "money_format":"{{amount}}TL",
    "money_with_currency_format":"{{amount}}TL"
  },
  "UGX":{
    "money_format":"Ush {{amount_no_decimals}}",
    "money_with_currency_format":"Ush {{amount_no_decimals}} UGX"
  },
  "UAH":{
    "money_format":"₴{{amount}}",
    "money_with_currency_format":"₴{{amount}} UAH"
  },
  "AED":{
    "money_format":"Dhs. {{amount}}",
    "money_with_currency_format":"Dhs. {{amount}} AED"
  },
  "UYU":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} UYU"
  },
  "VUV":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}}VT"
  },
  "VEF":{
    "money_format":"Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT":{
    "money_format":"{{amount_no_decimals}} BTC",
    "money_with_currency_format":"{{amount_no_decimals}} BTC"
  },
  "XOF":{
    "money_format":"CFA{{amount}}",
    "money_with_currency_format":"CFA{{amount}} XOF"
  },
  "ZMW":{
    "money_format":"K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};

Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
  
Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function(oldCurrency, newCurrency, selector, format) {
  jQuery(selector || 'span.money').each(function() {
    // If the amount has already been converted, we leave it alone.
    if (jQuery(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if (jQuery(this).attr('data-currency-'+newCurrency)) {
      jQuery(this).html(jQuery(this).attr('data-currency-'+newCurrency));
    }
    else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10)*100, oldCurrency, newCurrency);
      }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10)/10, oldCurrency, newCurrency);
      }
      else { 
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      jQuery(this).html(newFormattedAmount);
      jQuery(this).attr('data-currency-'+newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    jQuery(this).attr('data-currency', newCurrency);
  });
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};
/**
 * Clears contact us form
 */
function contactUsClear() {
    document.getElementById('FirstName').value = "";
    document.getElementById('LastName').value = "";
    document.getElementById('Email').value = "";
    document.getElementById('ContactFormSelect').selectedIndex = 0;
    document.getElementById('ContactFormMessage').value = "";
}

/**
 * Contact us event request
 * @param {event} event
 */
function contactUsRequest(event) {
    event.preventDefault();

    if (!document.getElementById('contact-us-form').reportValidity()) {
        document.getElementById('contact-us-form').reportValidity();
        return
    }

    var data = {
        "first_name": document.getElementById('FirstName').value,
        "last_name": document.getElementById('LastName').value,
        "email": document.getElementById('Email').value,
        "enquiry_select": document.getElementById('ContactFormSelect').value,
        "message": document.getElementById('ContactFormMessage').value,
        "url": document.URL,
        "host": window.location.host

    };

    var request = new XMLHttpRequest();

    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            contactUsClear();
            document.getElementById("SubmissionSuccess").className = "form-success";
        } else if (request.status === 500 || request.status === 404 || request.status === 400) {
            alert("There was an error please try against later or email us at customercare@nudebynature.com.au")
        }
    };

    request.open('POST', 'https://api.nudebynature.com/v2/support', true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
}


/**
 * Clears footer subscribe
 */
function subscriptionClear() {
    document.getElementById('subscribe-field').value = "";
}

/**
 * Subscribe event in the footer
 * @param {event} event
 */
function subscriptionRequest(event) {
    event.preventDefault();

    if (!document.getElementById('subscribe-field').reportValidity()) {
        document.getElementById('subscribe-field').reportValidity();
        return
    }

    if (blacklistedDomains(document.getElementById('subscribe-field').value)) {
        alert("Please contact customercare@nudebynature.com.au to get this email address added to the subscriber list.")
    } else {
        var data = {
            "email": document.getElementById('subscribe-field').value,
            "host": window.location.host
        };

        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
            if (request.readyState === 4 && request.status === 200) {
                subscriptionClear();
                document.getElementById("SubmissionSuccessFooter").className = "form-success";
            } else if (request.status === 500 || request.status === 404 || request.status === 400) {
                alert("There was an error please try against later or email us at customercare@nudebynature.com.au")
            }
        };

        request.open('POST', 'https://api.nudebynature.com/v2/contact/subscribe', true);
        request.setRequestHeader('Content-Type', 'application/json');
        request.send(JSON.stringify(data));

    }

}


/**
 * Clears subscription box on blo, exlusive offers subscribe box snippet
 */
function subscriptionClearBlog() {
    document.getElementById('subscribe-field-blog').value = "";
}

/**
 * Subscription box
 * On the blog page, exclusive offers subscribe box snippetpages
 * @param {event} event
 */
function subscriptionRequestBlog(event) {
    event.preventDefault();

    if (blacklistedDomains(document.getElementById('subscribe-field-blog').value)) {
        alert("Please contact customercare@nudebynature.com.au to get this email address added to the subscriber list.")
    } else {
        var data = {
            "email": document.getElementById('subscribe-field-blog').value,
            "host": window.location.host
        };

        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
            if (request.readyState === 4 && request.status === 200) {
                subscriptionClear();
                document.getElementById("SubmissionSuccessBlog").className = "form-success";
            } else if (request.status === 500 || request.status === 404 || request.status === 400) {
                alert("There was an error please try against later or email us at customercare@nudebynature.com.au")
            }
        };
        request.open('POST', 'https://api.nudebynature.com/v2/contact/subscribe', true);
        request.setRequestHeader('Content-Type', 'application/json');
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        request.send(JSON.stringify(data));

    }
}

/**
 * Clears activation form
 */
function activationClear() {
    document.getElementById('Email').value = "";
}

/**
 * Request to activate shopify account
 * @param {event} event
 */
function activationRequest(event) {
    event.preventDefault();

    var data = {
        "host": window.location.host,
        "email": document.getElementById("Email").value,
    };

    var request = new XMLHttpRequest();

    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            document.getElementById("activationSubmissionSuccess").className = "form-success";
            activationClear();
        } else if (request.status === 500 || request.status === 404 || request.status === 400) {
            alert("There was an error please try against later.")
        }
    };

    request.open('POST', 'https://api.nudebynature.com/v2/customers/activate', true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
}

/**
 * Updates the default address on /account?view=addresses
 * @param {event} event
 * @param id - Shopify ID of customer
 * @param addressId - Address ID of the customer
 */
function updateAddress(event, id, addressId) {
    event.preventDefault();

    var data = {
        "host": window.location.host,
        "id": id,
        "address_id": addressId,
        "first_name": document.getElementById('first_name').value,
        "last_name": document.getElementById('last_name').value,
        "address1": document.getElementById('address_1').value,
        "address2": document.getElementById('address_2').value,
        "city": document.getElementById('address_city').value,
        "country": document.getElementById('address_country').value,
        "country_name": document.getElementById('address_country').value,
        "company": document.getElementById('address_company').value,
        "phone": document.getElementById('address_phone').value,
        "province": document.getElementById('address_province').value,
        "zip": document.getElementById('address_zip').value,
    };

    var request = new XMLHttpRequest();
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            document.getElementById("alert_text").innerHTML = "Successfully submitted";
            document.getElementById('alert_area').style.display = 'block';
            setTimeout(function() {
                document.getElementById('alert_area').style.display = 'none';
            }, 2000)
        } else if (request.status === 500 || request.status === 404 || request.status === 400) {
            document.getElementById("alert_text").innerHTML = "There was an error, please try again later";
            document.getElementById('alert_area').style.display = 'block';
            setTimeout(function() {
                document.getElementById('alert_area').style.display = 'none';
            }, 2000)
        } else {
            document.getElementById("alert_text").innerHTML = "Submitted";
            document.getElementById('alert_area').style.display = 'block';
            setTimeout(function() {
                document.getElementById('alert_area').style.display = 'none';
            }, 2000)
        }
    };

    request.open('POST', `https://api.nudebynature.com/v2/customers/${id}/addresses/${addressId}`, true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
}

/**
 * Delete an address on /account?view=addresses
 * @param {event} event
 * @param id - Shopify ID of customer
 * @param addressId - Address ID of the customer
 */
function deleteAddress(event, id, addressId) {
    event.preventDefault();

    var data = {
        "host": window.location.host,
        "id": id,
        "address_id": addressId
    };

    var request = new XMLHttpRequest();
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            location.reload();
        } else if (request.status === 500 || request.status === 404 || request.status === 400) {
            alert("There was an error please try again later");
        }
    };

    request.open('DELETE', `https://api.nudebynature.com/v2/customers/${id}/addresses/${addressId}`, true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
}

/*=============== Vendors ================*/
// Check users opt in or out
if (getCookie('nbn-preferences') !== null && (getCookie('nbn-preferences').split(',')[2].split('=')[1] === 'true')) {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    switch (window.location.hostname)
    {
        case 'nudebynature.com.au': var gaId = "UA-19879111-1"; break;
        case 'nudebynature.co.nz': var gaId = "UA-19879111-28"; break;
        case 'nudebynature.com': var gaId = "UA-19879111-33"; break;
        case 'nudebynature.ca': var gaId = "UA-19879111-34"; break;
        case 'fr.nudebynature.ca': var gaId = "UA-19879111-34"; break;
        case 'nudebynature.co.uk': var gaId = "UA-19879111-29"; break;
        case 'nudebynature.eu': var gaId = "UA-19879111-32"; break;
        case 'nudebynature.fr': var gaId = "UA-19879111-31"; break;
        case 'nudebynature.de': var gaId = "UA-19879111-30"; break;
        case 'nudebynature.pl': var gaId = "UA-19879111-36"; break;
        default: var gaId = "UA-19879111-35"; break;
    }
    ga('create', gaId, 'auto');
    ga('require', 'ec');
    // Page view send handled in datalayer-pages.js
}

// Events handled in datalayer-events.js
// The add to cart event handled in functions.js in nbnCartSegment
// This is also added to checkout.liquid

// We need to have this because the objects in the dataLayer need to be defined because GA fires,
// as the first object in dataLayer must be the page view for GTM to exectue page view tags with
// the right data. This means we can't have this code in datalayer-pages.js which is loaded in
// datalayer.js which loads segment, instantiates the dataLayer and populates the dataLayer object with
// the page view data. This file will then load after GA has loaded and it will add all the enhanced
// ecommerce data and then send the pageview. This will disappear when we redo this through segment.

switch (window.pageData.name) {
    case 'index':
        if (check_ga() && checkHost(window.location.host)) { ga('send', 'pageview'); }
        break;
    case 'cart':
        if (check_ga() && checkHost(window.location.host)) {
            for (var i = 0; i < window.cartData.items.length; i += 1) {
                ga('ec:addProduct', {'id': window.cartData.items[i].product_id, 'name': window.cartData.items[i].title, 'category': window.cartData.items[i].product_type, 'variant': window.cartData.items[i].id, 'price': (window.cartData.items[i].price / 100).toFixed(2), 'quantity': window.cartData.items[i].quantity});
            }
            ga('ec:setAction', 'checkout', {'step': 1});
            ga('send', 'pageview');
        }
        break;
    case 'collection':
    case 'collection.nolayout':
    case 'list-collections':
        if (check_ga() && checkHost(window.location.host)) {
            var forLength = 0;
            // Check the length of the products on page
            if (window.collectionProducts < 4) {
                forLength = collectionProducts.length;
            } else {
                forLength = 3;
            }
            for (var i = 0; i < forLength; i += 1) {
                // update for non transactional
                if (window.location.host === 'nudebynature.com.au' || window.location.host === 'nudebynature.co.nz') {
                    ga('ec:addImpression', {
                        'id': window.collectionProducts[i].id,
                        'name': window.collectionProducts[i].title
                    });
                }
            }
            ga('send', 'pageview');
        }
        break;
    case 'search.cross-sell-all':
    case 'search.cross-sell-filters':
    case 'search':
        if (check_ga() && checkHost(window.location.host)) {
            // var forLength = 0;
            // // Check the length of the products on page
            // if (window.collectionProducts < 4) {
            //     forLength = collectionProducts.length;
            // } else {
            //     forLength = 3;
            // }
            // for (var i = 0; i < forLength; i += 1) {
            //     ga('ec:addImpression', {
            //         'id': window.collectionProducts[i].id,
            //         'name': window.collectionProducts[i].title
            //     });
            // }
            ga('send', 'pageview');
        }
        break;
    case 'product':
        if (check_ga() && checkHost(window.location.host)) {
            ga('ec:addProduct', {'id': window.productData.product_id, 'name': window.productData.item.name});
            ga('ec:setAction', 'detail');
            ga('send', 'pageview');
        }
        break;
    case '404':
    case 'page':
    case 'gift_card':
    case 'blog':
    case 'article':
    case 'page.contact':
    case 'page.stockists':
    case 'page.styles':
    case 'password':
    case 'customers/register':
    case 'customers/login':
    case 'customers/activate_account':
    case 'customers/addresses':
    case 'customers/order':
    case 'customers/reset_password':
        if (check_ga() && checkHost(window.location.host)) { ga('send', 'pageview'); }
        break;
    case 'customers/account':
        if (check_ga() && checkHost(window.location.host)) { ga('send', 'pageview'); }
        break;
}

// Declare this for the stock counter check on lipstick
var variantQuantities = [];

$(document).ready(function () {

    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Wrap videos in div to force responsive layout.
    slate.rte.wrapTable();
    slate.rte.iframeReset();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

      // Hide the GWP products by their ID
      // switch(window.location.hostname)
      // {
      //   case 'nudebynature.co.uk': var gwpIDs = ["712038514733"]; break;
      //   case 'nudebynature.eu': var gwpIDs = ["777009528892"]; break;
      //   case 'nudebynature.fr': var gwpIDs = ["1903662891066"]; break;
      //   case 'nudebynature.de': var gwpIDs = ["1450766368829"]; break;
      //   case 'nudebynature.pl': var gwpIDs = ["1903949774906"]; break;
      //   case 'nudebynature.co.nz': var gwpIDs = ["948596178991", "948590444591", "983834689583"]; break;
      //   case 'nudebynature.com.au': var gwpIDs = ["1463964467294", "1433277333598", "1433267372126", "1469467164766"]; break;
      //   default: var gwpIDs = ["1238023962668", "1216397672492", "1184540950572", "1285208539180"]; break;
      // }
    
      // for (let key in gwpIDs)
      //   $("#" + gwpIDs[key]).hide();
    

    /*=============== NbN Body JS ================*/
    Currency.format = window.currencyData.currencyFormat;
    var shopCurrency = window.currencyData.shopCurrency;
    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format = window.currencyData.moneyWithCurrencyFormat;
    Currency.moneyFormats[shopCurrency].money_format = window.currencyData.moneyFormat;
    
    /* Default currency */
    var defaultCurrency = window.currencyData.defaultCurrency;
    Currency.storeNativeCurrency = window.currencyData.shopCurrency;
    
    /* Cookie currency */
    if (window.currencyData.showMultipleCurrencies) {
      Currency.cookie.destroy();
    }
    
    var cookieCurrency = Currency.cookie.read();
    
    /* Fix for customer account pages */
    jQuery('span.money span.money').each(function() {
      jQuery(this).parents('span.money').removeClass('money');
    });
    /* Saving the current price */
    jQuery('span.money').each(function() {
      jQuery(this).attr('data-currency-' + shopCurrency, jQuery(this).html());
    });
    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      }
      else {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    }
    else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }
    jQuery('[name=currencies]').val(Currency.currentCurrency).change(function() {
      var newCurrency = jQuery(this).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      jQuery('.selected-currency').text(Currency.currentCurrency);
    });
    var original_selectCallback = window.selectCallback;
    var selectCallback = function(variant, selector) {
      original_selectCallback(variant, selector);
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
      jQuery('.selected-currency').text(Currency.currentCurrency);
    };
    $('body').on('ajaxCart.afterCartLoad', function(cart) {
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
      jQuery('.selected-currency').text(Currency.currentCurrency);
    });
    jQuery('.selected-currency').text(Currency.currentCurrency);
    
    /* ==================
       PAGE EVENTS
       ================== */
    var segCart = {"total": window.cartData.total, "currency": window.cartData.currency, "items": window.cartData.items};
    var segUser = {"id": window.custInfo.customer, "email": window.custInfo.email, "points": ""};
    
    // See if the user is logged in. These are more user ID focused events, such as login
    // This style of login cookie is only set for this login and nothing else
    if ((window.custInfo.customer != "") && (getCookie("nbn-user-loggedin") == null)) {
      // If we have a user id but no cookie, we can presume a fresh login
      var data = {
        'event': 'login',
        'site': window.location.hostname.split('.')[3] || window.location.hostname.split('.')[2],
        'language': navigator.language,
        'event_details': {
          'type': 'login',
          'category': 'login',
          'subcategory': '',
          'action': 'login',
          'label': 'login',
          'ecommerce_action': '',
        },
        'user': {
          'id': window.custInfo.customer,
          'email': window.custInfo.email,
          'first_name': window.userAccount.user.first_name,
          'last_name': window.userAccount.user.last_name,
          'address': {
            'address_1': window.userAccount.user.address.address1,
            'address_2': window.userAccount.user.address.address2,
            'city': window.userAccount.user.address.city,
            'state': window.userAccount.user.address.province,
            'postcode': window.userAccount.user.address.zip,
            'country': window.userAccount.user.address.country,
            'country_code': window.userAccount.user.address.country_code
          },
          'points': ''
        },
        'page': {
          'url': window.location.href
        },
        "integrations": userPrivacy
      };
      setCookie("nbn-user-loggedin", 1, 0);
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    }
    
    // Register
    $('#register-btn').on('click', function () {
      var data = {
        'event': 'account-registration',
        'event_details': {
          'type': 'new account',
          'category': 'new account',
          'subcategory': '',
          'action': 'new account',
          'label': 'new account',
          'ecommerce_action': '',
        },
        "site": window.location.hostname.split('.')[3] || window.location.hostname.split('.')[2],
        "language": navigator.language,
        "user": {"id": "", "email": $("#Email").val(), "points": ""},
        "cart": segCart,
        "page": {
          "type": "home",
          "title": window.pageData.title,
          "name": window.pageData.name,
          "url": window.location.href
        },
        "integrations": userPrivacy
      };
      $("#create_customer").submit();
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Logout button click
    $('a[href^="/account/logout"]').on('click', function (event) {
      var data = {
        'event': 'logout',
        'site': window.location.hostname.split('.')[3] || window.location.hostname.split('.')[2],
        'language': navigator.language,
        'event_details': {
          'type': 'logout',
          'category': 'logout',
          'subcategory': '',
          'action': 'logout',
          'label': 'logout',
          'ecommerce_action': ''
        },
        'user': {
          'id': window.custInfo.customer,
          'email': window.custInfo.email,
          'first_name': window.userAccount.user.first_name,
          'last_name': window.userAccount.user.last_name,
          'address': {
            'address_1': window.userAccount.user.address.address1,
            'address_2': window.userAccount.user.address.address2,
            'city': window.userAccount.user.address.city,
            'state': window.userAccount.user.address.province,
            'postcode': window.userAccount.user.address.zip,
            'country': window.userAccount.user.address.country,
            'country_code': window.userAccount.user.address.country_code
          },
          'points': ''
        },
        'page': {
          'url': window.location.href
        },
        "integrations": userPrivacy
      };
      window.dataLayer.push(data);
      // Clear the dataLayerEvents check cookie
      eraseCookie("nbn-user-loggedin");
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Cart related tracking can be found in additional-cart.js
    
    // Continue to checkout
    $('[data-continue-to-checkout]').on('click', function () {
      var data = {
        'event': 'continue-to-checkout',
        "site": window.location.hostname.split('.')[3] || window.location.hostname.split('.')[2],
        "language": navigator.language,
        "user": segUser,
        "cart": segCart,
        "page": {
          "type": "home",
          "title": window.pageData.title,
          "name": window.pageData.name,
          "url": window.location.href
        },
        "integrations": userPrivacy
      };
      window.dataLayer.push(data);
    });
    
    // Click Product Button
    $('#view-product-button').on('click', function () {
      var data = {
        'event': 'product-button-clicked',
        "site": window.location.hostname.split('.')[3] || window.location.hostname.split('.')[2],
        "language": navigator.language,
        "user": segUser,
        "cart": segCart,
        "page": {
          "type": "home",
          "title": window.pageData.title,
          "name": window.pageData.name,
          "url": window.location.href
        },
        "integrations": userPrivacy
      };
      window.dataLayer.push(data);
    });
    
    
    /* =========================
       GLOBAL
       ========================= */
    
    // Social media links
    $('.social-network-link').on('click', function () {
      var gaLabel = $(this).attr("href").split('/')[2];
      var data = {
        'event': 'social click',
        'event_details': {
          'type': 'social click',
          'category': 'social',
          'action': 'click',
          'label': gaLabel
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Email subscription footer
    $('#subscribe-form').submit(function () {
      var data = {
        'event': 'subscribe',
        'event_details': {
          'type': 'subscribe',
          'category': 'subscribe',
          'action': 'form',
          'label': 'footer',
          'value': 1
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Main navigation category click
    $('li.nav-item.dropdown').on('click', function () {
      var data = {
        'event': 'navigation',
        'event_details': {
          'type': 'navigation',
          'category': 'navigation',
          'action': 'click',
          'label': $(this).find('a').find('span').text()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // USP clicks
    for (var i = 0; i < document.getElementsByClassName('qualifier-block').length; i++) {
      var elem = document.getElementsByClassName('qualifier-block')[i];
      var elemLabel = elem.firstElementChild.href.split('/').pop();
      elem.addEventListener('click', function () {
        var data = {
          'event': 'USP Banner',
          'event_details': {
            'type': 'USP Banner',
            'category': 'USP Banner',
            'action': elemLabel.charAt(0).toUpperCase() + elemLabel.slice(1),
            'label': document.URL
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    ;
    
    
    // Cross sell
    // See snippets/cross-sell.liquid
    /*
    // CUSTOM - CROSS SELL TRACKING
        if (document.getElementById('cross-sell') !== null) {
            var parElem = document.getElementById('cross-sell');
            var childElems = parElem.querySelectorAll('.prod-column');
    
            // YOU MAY ALSO LIKE
            if (document.getElementsByClassName('cross-sell-title')[0].innerText === 'YOU MAY ALSO LIKE') {
                for (let i = 0; i < childElems.length; i++) {
                    childElems[i].querySelector('.coll-product-image-link').addEventListener('click', function () {
                        var data = {
                            'event': "You May Also Like",
                            'event_details': {
                                'type': "You May Also Like",
                                'category': "You May Also Like",
                                'action': childElems[i].querySelector('.coll-add-btn').href,
                                'label': "Image"
                            }
                        };
                        window.dataLayer.push(data);
                        if (check_ga()) {
                            ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
                        }
                    });
    
                    childElems[i].querySelector('.coll-product-title-link').addEventListener('click', function () {
                        var data = {
                            'event': "You May Also Like",
                            'event_details': {
                                'type': "You May Also Like",
                                'category': "You May Also Like",
                                'action': childElems[i].querySelector('.coll-product-title-link').href,
                                'label': "Title"
                            }
                        };
                        window.dataLayer.push(data);
                        if (check_ga()) {
                            ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
                        }
                    });
    
                    childElems[i].querySelector('.coll-add-btn').addEventListener('click', function () {
                        var data = {
                            'event': "You May Also Like",
                            'event_details': {
                                'type': "You May Also Like",
                                'category': "You May Also Like",
                                'action': childElems[i].querySelector('.coll-add-btn').href,
                                'label': "CTA"
                            }
                        };
                        window.dataLayer.push(data);
                        if (check_ga()) {
                            ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
                        }
                    });
    
                }
    
            // MOST LOVED
            } else if (document.getElementsByClassName('cross-sell-title')[0].innerText === 'MOST LOVED') {
                for (let i = 0; i < childElems.length; i++) {
                    childElems[i].querySelector('.coll-product-image-link').addEventListener('click', function () {
                        var data = {
                            'event': "Most Loved",
                            'event_details': {
                                'type': "Most Loved",
                                'category': "Most Loved",
                                'action': childElems[i].querySelector('.coll-add-btn').href,
                                'label': document.URL
                            }
                        };
                        window.dataLayer.push(data);
                        if (check_ga()) {
                            ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
                        }
                    });
    
                    childElems[i].querySelector('.coll-product-title-link').addEventListener('click', function () {
                        var data = {
                            'event': "Most Loved",
                            'event_details': {
                                'type': "Most Loved",
                                'category': "Most Loved",
                                'action': childElems[i].querySelector('.coll-product-title-link').href,
                                'label': document.URL
                            }
                        };
                        window.dataLayer.push(data);
                        if (check_ga()) {
                            ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
                        }
                    });
    
                    childElems[i].querySelector('.coll-add-btn').addEventListener('click', function () {
                        var data = {
                            'event': "Most Loved",
                            'event_details': {
                                'type': "Most Loved",
                                'category': "Most Loved",
                                'action': childElems[i].querySelector('.coll-add-btn').href,
                                'label': document.URL
                            }
                        };
                        window.dataLayer.push(data);
                        if (check_ga()) {
                            ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
                        }
                    });
    
                }
            }
        }
     */
    
    /* =========================
       HOMEPAGE
       ========================= */
    // if (window.pageData.name === "index") {
    //   document.getElementsByClassName('homepage-banner-section')[0].addEventListener('click', function (event) {
    //     var data = {
    //       'event': 'Hero Banner',
    //       'event_details': {
    //         'type': 'Hero Banner',
    //         'category': 'Hero Banner',
    //         'action': document.querySelector('div.homepage-banner-section > div.oc > a').href
    //       }
    //     };
    //     window.dataLayer.push(data);
    //     if (check_ga()) {
    //       ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
    //     }
    //   });
    // }
    
    /* =========================
       COLLECTION PAGES
       ========================= */
    
    // Sort by filter
    if (window.pageData.name === 'collection' && document.getElementById('sort-select') !== null) {
      document.getElementById('sort-select').addEventListener('change', function (event) {
        var gaAction = [];
        event.target.value.split('-').forEach(function (w) {
          gaAction.push(w.charAt(0).toUpperCase() + w.slice(1))
        });
        var data = {
          'event': 'All Sort Filter',
          'event_details': {
            'type': 'All Sort Filter',
            'category': 'All Sort Filter',
            'action': gaAction.join(' '),
            'label': document.URL
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    
    // Categories
    if (window.pageData.name === 'collection' && document.getElementById('collections-categories-filter') !== null) {
      document.getElementById('collections-categories-filter').addEventListener('click', function (event) {
        var gaAction = [];
        event.target.innerText.toLowerCase().split(' ').forEach(function (w) {
          gaAction.push(w.charAt(0).toUpperCase() + w.slice(1))
        });
        var data = {
          'event': 'Categories Filter',
          'event_details': {
            'type': 'Categories Filter',
            'category': 'Categories Filter',
            'action': gaAction.join(' '),
            'label': document.URL
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    
    /* =========================
       PRODUCT PAGE
       ========================= */
    
    // VTO
    if (window.pageData.name === "product" && document.querySelector('#vto-open') !== null) {
      document.querySelector("#vto-open").addEventListener('click', function () {
        var data = {
          'event': 'Virtual Try On (Product Page)',
          'event_details': {
            'type': 'Virtual Try On (Product Page)',
            'category': 'Virtual Try On (Product Page)',
            'action': 'Open',
            'label': document.URL
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    
    // VTO
    if (window.pageData.name === "product" && document.querySelector('#vto-close') !== null) {
        document.querySelector("#vto-close").addEventListener('click', function () {
            var data = {
                'event': 'Virtual Try On (Product Page)',
                'event_details': {
                    'type': 'Virtual Try On (Product Page)',
                    'category': 'Virtual Try On (Product Page)',
                    'action': 'Close',
                    'label': document.URL
                }
            };
            window.dataLayer.push(data);
            if (check_ga()) {
                ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
            }
        });
    }
    
    // HOW TO VIDEO
    if (window.pageData.name === "product" && document.querySelector('#how-to-use-it > div > video') !== null) {
      document.querySelector('#how-to-use-it > div > video').addEventListener('play', function () {
        var data = {
          'event': 'How To Video (Product Page)',
          'event_details': {
            'type': 'How To Video (Product Page)',
            'category': 'How To Video (Product Page)',
            'action': 'Play',
            'label': document.URL
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    
    // WHY WE LOVE IT accordion open
    if (window.pageData.name === "product" && document.getElementById('why-we-love-it') !== null) {
      $('.accordion').on('click', function () {
        if ($(this).hasClass('active')) {
          var data = {
            'event': 'accordion',
            'event_details': {
              'type': 'accordion',
              'category': 'accordion',
              'action': 'open',
              'label': 'why we love it'
            }
          };
        } else {
          var data = {
            'event': 'accordion',
            'event_details': {
              'type': 'accordion',
              'category': 'accordion',
              'action': 'close',
              'label': 'why we love it'
            }
          };
        }
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    
    // Product page event (different from a page view)
    if (window.pageData.name === 'product') {
      var data = {
        "event": "product page",
        'event_details': {
          'type': 'product',
          'category': 'product page',
          'action': 'view',
          'label': productData.item.name
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    }
    
    // Variant click
    $('li.option').on('click', function () {
      var data = {
        "event": "variant selection",
        'event_details': {
          'type': 'product',
          'category': 'variant click',
          'action': 'click',
          'label': $(this).children('label').attr('for')
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Canada only events
    if (window.location.host == 'nudebynature.ca' && document.URL.includes('products')) {
      $('#canada-find-a-store').on('click', function () {
        var data = {
          "event": "find a store",
          'event_details': {
            'type': 'find a store',
            'category': 'product',
            'action': 'click',
            'label': 'find a store'
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    
      $('#canada-buy-online').on('click', function () {
        var data = {
          "event": "buy online at shoppers",
          'event_details': {
            'type': 'buy online at shoppers',
            'category': 'product',
            'action': 'click',
            'label': 'buy online at shoppers'
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }
    
    
    /* =========================
       CUSTOMER SUCCESS
       ========================= */
    
    // Contact Us page form
    $('#contact-us-form').submit(function () {
      var data = {
        'event': 'contact us',
        'event_details': {
          'type': 'Customer success',
          'category': 'contact',
          'action': 'form',
          'label': 'Contact page',
          'value': 1
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    /* =========================
       FOUNDATION FINDER
       ========================= */
    
    // Get started button
    $('button.ff-btn-step-0-start').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Navigation events
    $('li.ff-btn-step-0-start').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': 'navigation coverage'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    $('li.ff-btn-step-1-next').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': 'navigation finish'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    $('li.ff-btn-step-2-next').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': 'navigation tone'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    $('li.ff-btn-step-3-next').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': 'navigation match'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Coverage selection
    $('button.ff-btn-step-1-next').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).data('coverage')
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Finish selection
    $('button.ff-btn-step-2-next').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).data('finish')
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Tone accordion
    $('a.ff-tone-accordion-toggle').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Tone selection
    $('a.ff-btn-step-3-next').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).data('tone')
        }
      };
      window.dataLayer.push(data);
      window.dataLayer.push({
        'event': 'foundation finder match',
        'event_details': {'type': 'foundation finder', 'category': 'foundation finder', 'action': 'view', 'label': 'match'}
      });
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        ga('send', 'event', data.event_details.category, 'view', 'match');
      }
    });
    
    // Add to bag button
    $('button.ff-step-4-add-btn').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).text().trim()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Add all to bag button
    $('button.ff-step-4-add-all-btn').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': $(this).text().trim()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Complete your complexion button click
    $('button.ff-collection-button').on('click', function () {
      var data = {
        'event': 'foundation finder',
        'event_details': {
          'type': 'foundation finder',
          'category': 'foundation finder',
          'action': 'click',
          'label': 'complete your complexion add to bag'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    
    /* =========================
       STORE LOCATOR
       ========================= */
    
    // Search click
    $('#storeSearchButton').on('click', function () {
      var data = {
        'event': 'store locator',
        'event_details': {
          'type': 'store locator',
          'category': 'store locator',
          'action': 'search',
          'label': 'store locator',
          'value': 1
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    /* =========================
       Lipstick Finder
       ========================= */
    
    // Get started button
    $('#lf-step-0').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Start again
    $('.lf-beginning').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'start again'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Step 1
    $('.lf-btn-step-1').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'step 1 - ' + $(this).html().toLowerCase().split('<')[0]
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Finish
    $('.lf-btn-step-finish').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'finish - ' + $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Colour
    $('.lf-btn-step-tone').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'tone - ' + $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Shade
    $('.lf-btn-step-colour').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'shade - ' + $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      window.dataLayer.push({
        'event': 'lipstick finder match',
        'event_details': {'type': 'lipstick finder', 'category': 'lipstick finder', 'action': 'view', 'label': 'match'}
      });
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        ga('send', 'event', data.event_details.category, 'view', 'match');
      }
    });
    
    // Look
    $('.lf-btn-step-look').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'look - ' + $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Match - Add to Bag
    $('button.lf-match-add-btn').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Match - Add all to Bag
    $('button.lf-step-match-add-all-btn').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': $(this).text().trim().toLowerCase()
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    // Match - Complete your look
    $('.lf-complete-product-button').on('click', function () {
      var data = {
        'event': 'Lipstick Finder',
        'event_details': {
          'type': 'Lipstick Finder',
          'category': 'Lipstick Finder',
          'action': 'click',
          'label': 'complete your look product'
        }
      };
      window.dataLayer.push(data);
      if (check_ga()) {
        ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
      }
    });
    
    
    /* =========================
       BLOG PAGES
       ========================= */
    if (window.location.pathname.includes("/blogs/")) {
      $('.blog-button').on('click', function () {
        var gaCategory = $(this).attr('href').split('/')[1].toLowerCase();
        var gaLabel = $(this).attr('href').split('/')[2].toLowerCase();
        var data = {
          'event': 'blog',
          'event_details': {
            'type': 'blog',
            'category': gaCategory,
            'action': 'click',
            'label': gaLabel
          }
        };
        window.dataLayer.push(data);
        if (check_ga()) {
          ga('send', 'event', data.event_details.category, data.event_details.action, data.event_details.label);
        }
      });
    }

    // When add to cart button is clicked, we can store the button object in a shared name space
    // So the cart js functions inside additional-cart.js can choose just one correct button
    $('[data-add-to-cart]').on('click', function () {
        window.selectorButton = {button: this};
    });

});

window.addEventListener("load", function() {
    // let lazyImages = [...document.querySelectorAll('.lazy-image')];
    // let inAdvance = 300;
    //
    // function lazyLoad() {
    //     lazyImages.forEach(image => {
    //         if (image.offsetTop < window.innerHeight + window.pageYOffset + inAdvance) {
    //             image.src = image.dataset.src;
    //             image.onload = () => {lazyImages = lazyImages.filter(item => item !== image);image.classList.add('loaded');}
    //         }
    //     })
    //
    //     // if all loaded removeEventListener
    // }
    //
    // lazyLoad();
    //
    // window.addEventListener('scroll', lazyLoad);
    // window.addEventListener('resize', lazyLoad);
    //
    // var lazyImages = [].concat(document.querySelectorAll('.lazy-image'));
    // var inAdvance = 300;
    //
    // function lazyLoad() {
    //     lazyImages.forEach(function (image) {
    //         if (image.offsetTop < window.innerHeight + window.pageYOffset + inAdvance) {
    //             image.src = image.dataset.src;
    //
    //             image.onload = function () {
    //                 lazyImages = lazyImages.filter(item => item !== image);
    //                 return image.classList.add('loaded');
    //             };
    //         }
    //     }); // if all loaded removeEventListener
    // }
    //
    // lazyLoad();
    // window.addEventListener('scroll', lazyLoad);
    // window.addEventListener('resize', lazyLoad);
    
    function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
    
    function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
    
    function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
    
    function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
    
    var lazyImages = _toConsumableArray(document.querySelectorAll('.lazy-image'));
    
    function lazyLoad(event) {
        // Remove events if no lazy loaded images remain
        if (lazyImages.length === 0) {
            window.removeEventListener('resize', lazyLoad);
            window.removeEventListener('scroll', lazyLoad);
            document.removeEventListener('click', lazyLoad);
        }
    
        lazyImages.forEach(function (image) {
            var bounding = image.getBoundingClientRect();
            // Check if images in top and bottom, Not worrying about left and right so carousel images are loaded
            if (
                (
                    bounding.top !== 0 && bounding.right !== 0 && bounding.bottom !== 0 && bounding.left !== 0
                )
                &&
                (
                    bounding.top >= -100
                    // && bounding.right <= (window.innerWidth + 100 || document.documentElement.clientWidth + 100)
                    && bounding.bottom <= (window.innerHeight + 100 || document.documentElement.clientHeight + 100)
                    // && bounding.left >= -100
                )
            ) {
                image.src = image.dataset.src;
    
                image.onload = function () {
                    // Remove the image from the lazyImages array so it doesn't continuously fire
                    lazyImages = lazyImages.filter(item => item !== image);
                    return image.classList.add('loaded');
                };
            }
        });
    }
    
    lazyLoad();
    window.addEventListener('scroll', lazyLoad);
    window.addEventListener('resize', lazyLoad);
    document.addEventListener('click', lazyLoad);
});




